var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagPor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2496 3649)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_487",
    "data-name": "Ret\\xE2ngulo 487",
    width: 102.857,
    height: 59.997,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_POR",
    transform: "translate(-2496 -3649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_portugal",
    transform: "translate(2480.168 3649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_484",
    "data-name": "Ret\\xE2ngulo 484",
    width: 66.881,
    height: 59.997,
    transform: "translate(35.976)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_485",
    "data-name": "Ret\\xE2ngulo 485",
    width: 35.976,
    height: 59.997,
    transform: "translate(0)",
    fill: "#2a680b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_808",
    "data-name": "Grupo 808",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_807",
    "data-name": "Grupo 807",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7063",
    "data-name": "Caminho 7063",
    d: "M606.457,30.041c-4.527-.132-25.286-13.1-25.428-15.171l1.142-1.908c2.063,3,23.286,15.607,25.371,15.159Z",
    transform: "translate(-558.759 9.263)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7064",
    "data-name": "Caminho 7064",
    d: "M582.012,12.953c-.41,1.1,5.423,4.7,12.426,8.962s13.048,6.9,13.5,6.531c.021-.051.218-.384.2-.384-.081.132-.29.166-.607.075-1.9-.545-6.831-2.814-12.945-6.528s-11.438-7.128-12.263-8.583a.939.939,0,0,1-.091-.424h-.017l-.173.307-.031.048Zm24.634,17.409c-.076.137-.216.149-.485.117-1.7-.189-6.835-2.694-12.92-6.329-7.075-4.242-12.916-8.105-12.282-9.117l.166-.305.039.009c-.574,1.711,11.531,8.64,12.241,9.077,7.013,4.345,12.908,6.884,13.432,6.222Z",
    transform: "translate(-558.843 9.007)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7065",
    "data-name": "Caminho 7065",
    d: "M606.386,30.542c-.058,0-.129-.007-.211-.012-1.728-.192-6.925-2.742-12.935-6.342-8.026-4.81-12.064-7.706-12.34-8.853a.425.425,0,0,1,.039-.321l.168-.3v.1l-.091.25a.321.321,0,0,0-.033.257c.273,1.12,4.3,4,12.3,8.8,6,3.594,11.185,6.135,12.9,6.322.25.026.382.021.446-.091l.11-.2a.5.5,0,0,1-.225.039c-1.423,0-6.721-2.364-13.108-6.33-.072-.039-.237-.137-.482-.281-7.826-4.609-11.795-7.536-11.809-8.7.165.763,1.992,2.814,11.848,8.623.252.146.418.242.485.286,6.377,3.951,11.653,6.312,13.065,6.312a.436.436,0,0,0,.305-.081l-.005.007a.105.105,0,0,1-.027.089l-.087.278a.326.326,0,0,1-.317.147m1.416-2.011c-1.048,0-6.781-2.557-13.366-6.567-7.544-4.59-12.846-7.925-12.445-9.014l.2-.362a.046.046,0,0,1,.012.024l-.117.326c-.425,1.149,6.379,5.3,12.385,8.954,6.577,4.005,12.285,6.552,13.326,6.552.084,0,.117-.014.129-.026.036-.072.077-.147.117-.211a.8.8,0,0,1-.506-.017c-2.08-.6-7.2-3.035-12.957-6.531-5.579-3.381-11.4-7.056-12.28-8.6a.992.992,0,0,1-.1-.446c.088.149.122.314.173.4.878,1.538,7.006,5.389,12.248,8.568,5.754,3.494,10.864,5.927,12.933,6.517.279.087.485.063.561-.053.089.027.089.033-.084.338-.089.129-.149.144-.237.144",
    transform: "translate(-558.862 8.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7066",
    "data-name": "Caminho 7066",
    d: "M594.562,16.164c4.533-.036,10.128-.616,13.345-1.9l-.694-1.128c-1.9,1.056-7.524,1.744-12.687,1.85-6.106-.051-10.41-.622-12.572-2.078l-.657,1.2c3.971,1.682,8.036,2.039,13.264,2.056",
    transform: "translate(-558.567 9.222)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7067",
    "data-name": "Caminho 7067",
    d: "M608.176,14.341a19.613,19.613,0,0,1-5.3,1.437,54.512,54.512,0,0,1-8.247.595,57.991,57.991,0,0,1-7.9-.5,22.957,22.957,0,0,1-5.542-1.469c.058-.113.1-.2.158-.3a24.494,24.494,0,0,0,5.439,1.437,58.293,58.293,0,0,0,7.838.5,54.911,54.911,0,0,0,8.179-.61c3.17-.514,4.909-1.168,5.147-1.478Zm-.61-1.144a16.128,16.128,0,0,1-5.07,1.365,54.548,54.548,0,0,1-7.834.55,51.911,51.911,0,0,1-7.567-.49,20.51,20.51,0,0,1-5.279-1.332c.067-.1.12-.192.185-.3a17.785,17.785,0,0,0,5.134,1.31,54.16,54.16,0,0,0,7.527.47,54.221,54.221,0,0,0,7.778-.55,13.635,13.635,0,0,0,4.909-1.389Z",
    transform: "translate(-558.646 9.168)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7068",
    "data-name": "Caminho 7068",
    d: "M594.517,16.428a58.384,58.384,0,0,1-7.8-.5,23.4,23.4,0,0,1-5.5-1.449l-.019-.192.1-.2a26.6,26.6,0,0,0,5.483,1.415,57.567,57.567,0,0,0,7.779.5,55.842,55.842,0,0,0,8.225-.609c3.138-.508,4.883-1.157,5.12-1.463l.3.394c-.135.249-2.31.976-5.331,1.5a54.326,54.326,0,0,1-8.254.6Zm-13.2-2.28-.1.288a27.6,27.6,0,0,0,5.514,1.406,58.3,58.3,0,0,0,7.784.5v.045l.1-.045a55,55,0,0,0,8.239-.6,20.115,20.115,0,0,0,5.274-1.415l-.225-.345c-.165.3-1.771.957-5.1,1.5a55.058,55.058,0,0,1-8.191.61,57.576,57.576,0,0,1-7.851-.506,24.083,24.083,0,0,1-5.44-1.442m13.28,1.018a53.567,53.567,0,0,1-7.519-.485,20.387,20.387,0,0,1-5.036-1.243l-.247-.093.106-.274c.009-.027.082-.1.1-.1a17.62,17.62,0,0,0,5.116,1.307,54.167,54.167,0,0,0,7.474.468,54.468,54.468,0,0,0,7.819-.554,13.9,13.9,0,0,0,4.894-1.377l.281.377c-.346.322-2.016.943-5.1,1.43a53.42,53.42,0,0,1-7.841.549Zm-12.628-2.123-.12.281.228.033a20.208,20.208,0,0,0,5.014,1.24,53.3,53.3,0,0,0,7.507.487v.043l.053-.043a54.466,54.466,0,0,0,7.827-.552c3.064-.489,4.722-1.091,5.048-1.356l-.23-.312c-.159.189-1.733.976-4.863,1.409a53.829,53.829,0,0,1-7.783.552,53.791,53.791,0,0,1-7.541-.472,17.445,17.445,0,0,1-5.14-1.31",
    transform: "translate(-558.636 9.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7069",
    "data-name": "Caminho 7069",
    d: "M580.362,18.574c2.783,1.5,8.978,2.26,14.835,2.311,5.339.009,12.287-.823,14.886-2.207l-.074-1.5c-.811,1.276-8.261,2.49-14.866,2.442s-12.75-1.068-14.794-2.394Z",
    transform: "translate(-559.245 12.275)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7070",
    "data-name": "Caminho 7070",
    d: "M610.3,18.418v.357c-.386.463-2.839,1.173-5.914,1.67a60.834,60.834,0,0,1-9.178.631,58.255,58.255,0,0,1-8.715-.6,21.875,21.875,0,0,1-6.238-1.685v-.415c1.368.9,5.05,1.562,6.286,1.771a58.14,58.14,0,0,0,8.667.595,61.231,61.231,0,0,0,9.13-.624c2.2-.321,5.344-1.151,5.962-1.7m0-1.281V17.5c-.386.47-2.838,1.173-5.914,1.67a60.541,60.541,0,0,1-9.178.634,57.544,57.544,0,0,1-8.715-.6,21.767,21.767,0,0,1-6.238-1.685l.007-.417c1.361.907,5.043,1.565,6.279,1.773a57.228,57.228,0,0,0,8.667.595,60.06,60.06,0,0,0,9.13-.626c2.208-.321,5.351-1.145,5.962-1.7",
    transform: "translate(-559.316 12.219)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7071",
    "data-name": "Caminho 7071",
    d: "M595.222,21.114a57.566,57.566,0,0,1-8.722-.6,21.886,21.886,0,0,1-6.252-1.689l-.024-.449c1.433.868,5.207,1.541,6.336,1.725a57.606,57.606,0,0,0,8.662.595,61.434,61.434,0,0,0,9.124-.622c2.195-.321,5.326-1.14,5.941-1.691l.072.391c-.413.513-2.915,1.224-5.953,1.709a60.63,60.63,0,0,1-9.184.631m-14.974-2.7.065.382a23.215,23.215,0,0,0,6.2,1.639,58.078,58.078,0,0,0,8.712.6,60.941,60.941,0,0,0,9.172-.629c2.963-.478,5.5-1.192,5.89-1.655l-.012-.329c-.554.583-3.71,1.418-5.914,1.732a60.011,60.011,0,0,1-9.136.626,57.287,57.287,0,0,1-8.671-.592c-1.452-.237-4.966-.881-6.3-1.775m14.974,1.435a57.265,57.265,0,0,1-8.722-.607,21.9,21.9,0,0,1-6.252-1.687l-.017-.453c1.427.871,5.2,1.545,6.329,1.727a58.037,58.037,0,0,0,8.662.6,60.734,60.734,0,0,0,9.124-.626c2.195-.319,5.326-1.14,5.941-1.687l.072.389c-.41.509-2.915,1.224-5.946,1.711a60.856,60.856,0,0,1-9.19.634m-14.974-2.711.065.381a23.031,23.031,0,0,0,6.2,1.643,58.49,58.49,0,0,0,8.707.595,61.434,61.434,0,0,0,9.172-.622c2.975-.485,5.507-1.193,5.89-1.661l-.012-.331c-.555.595-3.716,1.43-5.914,1.742a60.214,60.214,0,0,1-9.136.628,57.905,57.905,0,0,1-8.671-.595c-1.452-.24-4.966-.886-6.3-1.778",
    transform: "translate(-559.335 12.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7072",
    "data-name": "Caminho 7072",
    d: "M594.45,23.632a51.563,51.563,0,0,1-13.066-2.027l.845,1.32a34.98,34.98,0,0,0,12.277,2.006c4.876-.139,9.132-.521,12.133-1.982l.863-1.373c-2.044.96-9,2.047-13.052,2.056",
    transform: "translate(-558.506 15.419)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7073",
    "data-name": "Caminho 7073",
    d: "M607.076,22.714c-.129.2-.261.386-.386.574a34.186,34.186,0,0,1-4.592,1.173,40.867,40.867,0,0,1-7.536.691,36.237,36.237,0,0,1-12.513-2.136l-.175-.309.026-.045.3.113a40.261,40.261,0,0,0,12.4,2.051,41.383,41.383,0,0,0,7.388-.689,21.783,21.783,0,0,0,4.983-1.365Zm.751-1.24.007.005c-.1.166-.192.331-.292.492a32.106,32.106,0,0,1-5.794,1.293,46.325,46.325,0,0,1-7.117.6,48.887,48.887,0,0,1-13.234-1.98l-.168-.326a55.855,55.855,0,0,0,13.4,1.975,50.427,50.427,0,0,0,7.069-.612,36.8,36.8,0,0,0,5.77-1.279c-.005-.014-.017-.026-.017-.034Z",
    transform: "translate(-558.616 15.346)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7074",
    "data-name": "Caminho 7074",
    d: "M594.579,25.212h0a35.738,35.738,0,0,1-12.532-2.147l-.2-.322c.012-.015.06-.106.079-.106l.305.12A39.586,39.586,0,0,0,594.612,24.8h0a41.928,41.928,0,0,0,7.375-.686,20.213,20.213,0,0,0,4.976-1.361.24.24,0,0,1,.079-.024l.009-.021.039.024-.007.005c.017.007.045.007.039.015-.129.194-.255.389-.386.578a33.965,33.965,0,0,1-4.612,1.19,41.336,41.336,0,0,1-7.548.693M581.9,22.719l.2.286a36.8,36.8,0,0,0,12.482,2.126,41.165,41.165,0,0,0,7.524-.693,34.563,34.563,0,0,0,4.583-1.169c.081-.135.178-.276.274-.42a22.416,22.416,0,0,1-4.955,1.348,42.245,42.245,0,0,1-7.279.688A40.342,40.342,0,0,1,582.2,22.835Zm12.747,1.205h0a49.537,49.537,0,0,1-13.244-1.98l-.2-.341a59.589,59.589,0,0,0,13.441,1.908,47.551,47.551,0,0,0,6.416-.521l.646-.086a37.64,37.64,0,0,0,5.693-1.257l.429-.2-.015.029-.336.192a31.71,31.71,0,0,1-5.761,1.31l-.636.091a47.541,47.541,0,0,1-6.435.523,55.932,55.932,0,0,1-13.414-1.975l.218.266a50.068,50.068,0,0,0,13.2,1.958,42.736,42.736,0,0,0,6.27-.489l.835-.113a32.475,32.475,0,0,0,5.794-1.293l.269-.461-.228.521a31.023,31.023,0,0,1-5.818,1.312l-.84.117a42.035,42.035,0,0,1-6.282.487",
    transform: "translate(-558.632 15.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7075",
    "data-name": "Caminho 7075",
    d: "M595.107,10.265A13.34,13.34,0,1,1,581.782,23.6a13.337,13.337,0,0,1,13.324-13.338m0-1.32A14.66,14.66,0,1,1,580.469,23.6,14.683,14.683,0,0,1,595.107,8.945",
    transform: "translate(-559.16 6.392)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7076",
    "data-name": "Caminho 7076",
    d: "M595.2,8.844a14.851,14.851,0,1,1-14.842,14.85A14.875,14.875,0,0,1,595.2,8.844m0,.326a14.526,14.526,0,1,1-14.514,14.525A14.579,14.579,0,0,1,595.2,9.17",
    transform: "translate(-559.24 6.32)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7077",
    "data-name": "Caminho 7077",
    d: "M595.216,38.611a14.9,14.9,0,1,1,14.883-14.9,14.9,14.9,0,0,1-14.883,14.9m0-29.706a14.81,14.81,0,1,0,14.8,14.811,14.821,14.821,0,0,0-14.8-14.811m0,29.377a14.568,14.568,0,1,1,14.557-14.566,14.578,14.578,0,0,1-14.557,14.566m0-29.048a14.481,14.481,0,1,0,14.468,14.482A14.492,14.492,0,0,0,595.216,9.235",
    transform: "translate(-559.257 6.302)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7078",
    "data-name": "Caminho 7078",
    d: "M594.69,9.564a13.606,13.606,0,1,1-13.6,13.607,13.653,13.653,0,0,1,13.6-13.607m0,.326a13.276,13.276,0,1,1-13.27,13.282A13.329,13.329,0,0,1,594.69,9.89",
    transform: "translate(-558.714 6.835)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7079",
    "data-name": "Caminho 7079",
    d: "M594.709,36.836A13.648,13.648,0,1,1,608.34,23.189a13.661,13.661,0,0,1-13.631,13.647m0-27.213a13.564,13.564,0,1,0,13.546,13.566A13.575,13.575,0,0,0,594.709,9.623m0,26.884a13.321,13.321,0,1,1,13.3-13.318,13.333,13.333,0,0,1-13.3,13.318m0-26.558a13.237,13.237,0,1,0,13.221,13.24,13.256,13.256,0,0,0-13.221-13.24",
    transform: "translate(-558.732 6.817)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_486",
    "data-name": "Ret\\xE2ngulo 486",
    width: 1.296,
    height: 29.883,
    transform: "translate(35.357 15.094)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7080",
    "data-name": "Caminho 7080",
    d: "M589.827,8.708h.321V38.9h-.321Zm-1.272,0h.329l.005,30.191h-.334Z",
    transform: "translate(-553.381 6.223)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7081",
    "data-name": "Caminho 7081",
    d: "M590.163,38.959h-.321L589.8,8.724l.365-.039.045,30.231c0,.007-.005.015-.017.027a.035.035,0,0,1-.027.015m-.045-30.234-.276.045.043,30.147.233-.038Zm-1.212,30.234h-.334l-.038-30.234.365-.039.051,30.231c0,.007-.012.015-.017.027s-.019.015-.028.015m-.048-30.234-.286.045.044,30.147.242-.038Z",
    transform: "translate(-553.396 6.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7082",
    "data-name": "Caminho 7082",
    d: "M580.327,18.3c1.864-1.715,8.727-2.827,14.821-2.8s13.306,1.281,14.876,2.766l.012,1.274c-1.317-1.233-6.917-2.711-14.876-2.728s-13.741,1.5-14.833,2.762Z",
    transform: "translate(-559.261 11.08)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7083",
    "data-name": "Caminho 7083",
    d: "M580.386,18.289l-.087-1.1c0-.051.087-.051.087,0Z",
    transform: "translate(-559.281 12.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7084",
    "data-name": "Caminho 7084",
    d: "M597.737,18.32l-.089-1.108c0-.045.089-.045.089,0Z",
    transform: "translate(-546.883 12.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7085",
    "data-name": "Caminho 7085",
    d: "M595.284,16.7a52.136,52.136,0,0,1,9.605.856c2.781.561,4.736,1.255,5.408,2.042v.386c-.808-.974-3.441-1.689-5.473-2.1a50.559,50.559,0,0,0-9.54-.854,53.27,53.27,0,0,0-9.739.866c-2.116.425-4.935,1.262-5.3,2.083v-.4c.2-.569,2.3-1.425,5.247-2.011a52.969,52.969,0,0,1,9.791-.871m.005-1.272a51.761,51.761,0,0,1,9.6.859c2.781.559,4.736,1.253,5.408,2.032V18.7c-.8-.972-3.441-1.684-5.466-2.092a50.7,50.7,0,0,0-9.542-.849,53.271,53.271,0,0,0-9.729.864c-2.035.389-4.978,1.26-5.314,2.076v-.4c.2-.562,2.34-1.451,5.254-2.011a53.235,53.235,0,0,1,9.789-.868",
    transform: "translate(-559.318 11.022)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7086",
    "data-name": "Caminho 7086",
    d: "M580.263,20.042l0-.007a.041.041,0,0,1-.036-.039v-.4c.209-.633,2.43-1.488,5.281-2.058a53.449,53.449,0,0,1,9.794-.871,52.2,52.2,0,0,1,9.612.859c2.906.585,4.791,1.293,5.435,2.051l.012.418c-.934-1-3.858-1.716-5.531-2.052a50.6,50.6,0,0,0-9.415-.85,54.1,54.1,0,0,0-9.84.866c-2.308.461-4.942,1.3-5.264,2.056a.048.048,0,0,1-.046.027M595.3,17.007a51.28,51.28,0,0,1,9.549.849c1.679.336,4.624,1.06,5.5,2.111l-.075-.357c-.631-.72-2.49-1.421-5.379-2a51.759,51.759,0,0,0-9.52-.856,53.629,53.629,0,0,0-9.852.871c-3.164.631-5.043,1.49-5.207,1.984v.231c.622-.847,3.537-1.629,5.24-1.97a53.518,53.518,0,0,1,9.746-.864M580.27,18.763h-.007a.04.04,0,0,1-.038-.041v-.4c.214-.638,2.49-1.512,5.285-2.059a53.533,53.533,0,0,1,9.8-.864,51.942,51.942,0,0,1,9.61.856c2.9.58,4.787,1.293,5.437,2.056l.007.41c-.931-1-3.853-1.715-5.526-2.052a51.437,51.437,0,0,0-9.453-.85,53.819,53.819,0,0,0-9.794.868c-2.339.449-4.984,1.313-5.273,2.054a.054.054,0,0,1-.045.026m15.036-3.028a51.062,51.062,0,0,1,9.544.85c1.686.338,4.633,1.06,5.5,2.1l-.075-.357c-.631-.715-2.49-1.413-5.379-1.994a51.137,51.137,0,0,0-9.48-.859,54.111,54.111,0,0,0-9.885.866c-3.045.595-5.043,1.481-5.214,1.987v.23c.6-.82,3.412-1.61,5.259-1.963a53.162,53.162,0,0,1,9.732-.864",
    transform: "translate(-559.334 11.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7087",
    "data-name": "Caminho 7087",
    d: "M594.485,11.633c5.519-.029,10.334.778,12.539,1.9l.806,1.392c-1.919-1.036-7.111-2.107-13.342-1.948-5.07.033-10.5.559-13.216,2.008l.96-1.6c2.236-1.157,7.5-1.747,12.253-1.751",
    transform: "translate(-558.586 8.313)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7088",
    "data-name": "Caminho 7088",
    d: "M594.593,12.835a50.02,50.02,0,0,1,8.611.607,15.748,15.748,0,0,1,4.717,1.385l.233.422a17.337,17.337,0,0,0-5-1.483,48.074,48.074,0,0,0-8.568-.593,49.706,49.706,0,0,0-8.691.59,15.511,15.511,0,0,0-4.678,1.457l.237-.446a15.388,15.388,0,0,1,4.384-1.337,50.92,50.92,0,0,1,8.753-.6m-.005-1.272a48.291,48.291,0,0,1,8.318.578,13.312,13.312,0,0,1,4.293,1.406l.357.55c-.6-.655-2.827-1.281-4.794-1.627a52.7,52.7,0,0,0-8.174-.581,50.3,50.3,0,0,0-8.359.614,13.552,13.552,0,0,0-4.144,1.281l.3-.461a14.846,14.846,0,0,1,3.8-1.149,50.293,50.293,0,0,1,8.4-.61",
    transform: "translate(-558.624 8.262)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7089",
    "data-name": "Caminho 7089",
    d: "M608.143,15.31l-.021-.009a17.3,17.3,0,0,0-4.983-1.476,46.662,46.662,0,0,0-8.285-.595l-.278,0-.324,0a48.357,48.357,0,0,0-8.361.592,15.258,15.258,0,0,0-4.657,1.449l.17-.5a15.732,15.732,0,0,1,4.412-1.36,49.791,49.791,0,0,1,8.765-.6h.187a49.4,49.4,0,0,1,8.436.607c2.3.429,4.42,1.053,4.732,1.4l.249.425a.068.068,0,0,1-.007.058.091.091,0,0,1-.036.009m-13.374-2.419h-.187a50.746,50.746,0,0,0-8.75.6,16.044,16.044,0,0,0-4.371,1.337l-.209.429a12.254,12.254,0,0,1,4.621-1.521,49.2,49.2,0,0,1,8.379-.588h.6a47.233,47.233,0,0,1,8.3.588,19.03,19.03,0,0,1,4.869,1.408l-.153-.281a16.062,16.062,0,0,0-4.686-1.363,49.5,49.5,0,0,0-8.419-.61m12.776,1.272c-.017,0-.021-.009-.033-.014-.614-.682-2.954-1.3-4.773-1.62a51.9,51.9,0,0,0-8.162-.583,50.336,50.336,0,0,0-8.347.616,13.907,13.907,0,0,0-4.136,1.279l.249-.525a14.621,14.621,0,0,1,3.818-1.168,49.96,49.96,0,0,1,8.415-.612h.245a47.821,47.821,0,0,1,8.074.578,13.335,13.335,0,0,1,4.324,1.415l.36.566a.043.043,0,0,1-.012.057.04.04,0,0,1-.024.012m-12.968-2.3a51.356,51.356,0,0,1,8.179.583,13.937,13.937,0,0,1,4.592,1.449l-.192-.305a13.425,13.425,0,0,0-4.273-1.391,47.776,47.776,0,0,0-8.06-.576h-.245a50.3,50.3,0,0,0-8.4.61,15.014,15.014,0,0,0-3.777,1.142l-.293.454a11.361,11.361,0,0,1,4.1-1.348,48.564,48.564,0,0,1,8.366-.619",
    transform: "translate(-558.612 8.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7090",
    "data-name": "Caminho 7090",
    d: "M601.908,21.869a38.019,38.019,0,0,0-7.378-.566c-9.2.1-12.177,1.891-12.543,2.43l-.688-1.121c2.346-1.7,7.356-2.653,13.278-2.557a47.32,47.32,0,0,1,7.964.686Z",
    transform: "translate(-558.566 14.327)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7091",
    "data-name": "Caminho 7091",
    d: "M594.526,21.223a45.317,45.317,0,0,1,7.5.6l-.175.31a38.918,38.918,0,0,0-7.316-.559,35.273,35.273,0,0,0-9.823,1.145c-.948.264-2.514.871-2.67,1.372l-.17-.288c.05-.293.993-.91,2.762-1.409a35.764,35.764,0,0,1,9.888-1.169m.113-1.288a45.542,45.542,0,0,1,8.057.7l-.18.321a42.128,42.128,0,0,0-7.853-.686,37.656,37.656,0,0,0-10.31,1.207c-1.063.314-2.9.981-2.954,1.507l-.173-.314c.039-.482,1.622-1.1,3.05-1.523a37.885,37.885,0,0,1,10.363-1.216",
    transform: "translate(-558.619 14.246)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7092",
    "data-name": "Caminho 7092",
    d: "M582.062,24.149a.044.044,0,0,1-.033-.014l-.177-.3c.052-.357,1.051-.976,2.79-1.466a35.364,35.364,0,0,1,9.9-1.175,45.35,45.35,0,0,1,7.508.6l-.146.372a41.368,41.368,0,0,0-7.021-.538l-.329,0-.389,0a34.376,34.376,0,0,0-9.427,1.149c-1.006.281-2.484.883-2.634,1.344a.052.052,0,0,1-.036.026Zm12.481-2.86a35.036,35.036,0,0,0-9.88,1.164c-1.787.506-2.688,1.116-2.733,1.373l.127.2c.307-.562,2-1.144,2.663-1.329a34.827,34.827,0,0,1,9.446-1.149l.389,0,.329,0a38.517,38.517,0,0,1,6.99.566l.132-.293a51.588,51.588,0,0,0-7.464-.53m-13.127,1.756a.049.049,0,0,1-.039-.021l-.173-.305c.045-.658,2.368-1.382,3.078-1.589a37.4,37.4,0,0,1,10.375-1.221,46.736,46.736,0,0,1,8.069.71l-.156.377a45.388,45.388,0,0,0-7.889-.665,36.817,36.817,0,0,0-10.3,1.2c-1.374.406-2.87,1.032-2.927,1.473a.044.044,0,0,1-.032.038Zm13.24-3.052A37.235,37.235,0,0,0,584.3,21.21c-1.806.525-2.99,1.115-3.023,1.485l.118.207c.3-.65,2.673-1.365,2.951-1.444A36.969,36.969,0,0,1,594.68,20.25a42.77,42.77,0,0,1,7.862.689l.139-.3a51.6,51.6,0,0,0-8.024-.646",
    transform: "translate(-558.635 14.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7093",
    "data-name": "Caminho 7093",
    d: "M587.447,20.567a.185.185,0,0,1,.048-.111.143.143,0,0,1,.165-.036.094.094,0,0,1,.039.046.146.146,0,0,1,.012.074.184.184,0,0,1-.024.079.245.245,0,0,1-.046.053.151.151,0,0,1-.074.017.12.12,0,0,1-.067-.005.131.131,0,0,1-.041-.048.139.139,0,0,1-.012-.069m.039,0a.1.1,0,0,0,.021.077.066.066,0,0,0,.06.022.1.1,0,0,0,.074-.036.159.159,0,0,0,.031-.087.077.077,0,0,0-.007-.053c-.005-.021-.014-.031-.024-.033a.139.139,0,0,0-.05-.015.2.2,0,0,0-.072.033.2.2,0,0,0-.033.093m.35.045.033-.009a.058.058,0,0,0,.016.033c.005.007.017.009.033.009a.056.056,0,0,0,.033-.014l.019-.015c0-.015,0-.021-.007-.024a.085.085,0,0,0-.033-.012c-.028,0-.045-.009-.052-.009l-.021-.021a.044.044,0,0,1-.005-.027.028.028,0,0,1,.012-.024l.014-.019.024-.01a.037.037,0,0,1,.028-.01.06.06,0,0,1,.045.01.019.019,0,0,1,.019.017c.005,0,.005.015.012.024l-.036.012c0-.012,0-.019-.007-.024a.047.047,0,0,0-.033-.009.211.211,0,0,0-.033.009l-.012.017v.007c.005.012.012.015.017.015a.077.077,0,0,0,.028.005c.021.007.039.009.051.012l.017.021V20.6a.074.074,0,0,1-.012.036l-.029.024a.183.183,0,0,1-.043.005c-.029,0-.045,0-.057-.012a.078.078,0,0,1-.021-.045m.338-.029.033.009a.086.086,0,0,1-.033.048.076.076,0,0,1-.06.017.062.062,0,0,1-.065-.021.121.121,0,0,1-.015-.081.113.113,0,0,1,.036-.075.083.083,0,0,1,.069-.029.115.115,0,0,1,.064.019.119.119,0,0,1,.012.081v0l-.144.015a.067.067,0,0,0,.012.048c.005.012.024.015.039.012a.053.053,0,0,0,.029-.005.14.14,0,0,0,.024-.039m-.1-.045.108,0c0-.019,0-.031-.009-.036s-.024-.019-.041-.019a.042.042,0,0,0-.034.019.048.048,0,0,0-.024.039m.165.125h.027a.046.046,0,0,0,.012.024.08.08,0,0,0,.033.005.111.111,0,0,0,.036-.009c.012-.009.012-.017.019-.029s.005-.019.009-.043a.085.085,0,0,1-.057.027.049.049,0,0,1-.057-.027.1.1,0,0,1-.022-.069.2.2,0,0,1,.022-.053.056.056,0,0,1,.036-.039.064.064,0,0,1,.041-.017.051.051,0,0,1,.053.026l.007-.026h.027l-.022.177a.144.144,0,0,1-.012.065.123.123,0,0,1-.033.029.116.116,0,0,1-.053.015.069.069,0,0,1-.055-.015c-.012-.012-.024-.021-.017-.041Zm.039-.125c0,.026,0,.045.012.057s.015.017.033.017.024-.009.043-.021a.308.308,0,0,0,.021-.053c0-.034,0-.048-.012-.058a.042.042,0,0,0-.072,0,.165.165,0,0,0-.024.058m.171.093.026-.2h.031v.033c0-.009.017-.017.024-.026a.068.068,0,0,1,.036-.01.1.1,0,0,1,.036.007c.009,0,.009.021.014.029a.075.075,0,0,1,.067-.036.1.1,0,0,1,.044.01.112.112,0,0,1,0,.057l-.015.134h-.033l.014-.125v-.029c0-.01,0-.01-.01-.012l-.01-.007a.213.213,0,0,0-.041.009.131.131,0,0,0-.024.051l-.009.117h-.036l.017-.129a.1.1,0,0,0-.005-.039l-.022,0-.026,0c-.007.01-.019.015-.024.027s-.007.017-.012.041l-.009.1Zm.458-.081.033,0a.074.074,0,0,1-.039.048.081.081,0,0,1-.057.022.063.063,0,0,1-.057-.027.09.09,0,0,1-.024-.072.157.157,0,0,1,.041-.081.083.083,0,0,1,.07-.031.076.076,0,0,1,.077.1l-.007.012H588.8a.122.122,0,0,0,.007.053.046.046,0,0,0,.038.015.089.089,0,0,0,.034-.012.113.113,0,0,0,.024-.029m-.1-.051h.111c0-.019-.007-.039-.012-.039s-.024-.026-.039-.026-.027.017-.039.024-.017.022-.021.041m.164.113.028-.2h.033v.022c.009-.019.033-.024.06-.024.012-.01.027,0,.039,0l.012.012a.088.088,0,0,1,.009.027v.029l-.015.123-.033.007.015-.123v-.029l-.015-.024-.024,0c-.012,0-.021,0-.039.021a.116.116,0,0,0-.021.051l-.012.11Zm.29-.038V20.6h-.029c-.009.007-.016,0-.021,0s-.012-.009-.019-.017a.16.16,0,0,1,.007-.039l.017-.117h-.029l.005-.017h.024l.012-.055.033-.021-.012.075.034-.01v.027h-.034l-.017.117,0,.021,0,.007.005,0Zm.034-.072c.005-.043.014-.069.038-.079a.076.076,0,0,1,.064-.029.06.06,0,0,1,.06.029c.017.01.024.036.017.075a.1.1,0,0,1-.021.057.368.368,0,0,1-.033.036.166.166,0,0,1-.057.012.092.092,0,0,1-.06-.024.09.09,0,0,1-.009-.077m.033,0a.076.076,0,0,0,.005.053.037.037,0,0,0,.036.021.062.062,0,0,0,.045-.021.134.134,0,0,0,.028-.057.162.162,0,0,0-.005-.057.051.051,0,0,0-.045-.019.065.065,0,0,0-.046.019.114.114,0,0,0-.017.06m.418.033.034,0a.164.164,0,0,1-.046.045.064.064,0,0,1-.053.017.072.072,0,0,1-.067-.026.124.124,0,0,1-.009-.075c.007-.039.015-.065.039-.075a.08.08,0,0,1,.069-.036.074.074,0,0,1,.06.036c.012.01.012.036.012.075l-.005.005h-.142a.055.055,0,0,0,.01.051c.005.015.024.019.038.019a.071.071,0,0,0,.033-.01.14.14,0,0,1,.027-.029m-.1-.055h.108a.1.1,0,0,0-.007-.046.067.067,0,0,0-.039-.01.086.086,0,0,0-.041.01.1.1,0,0,0-.021.046m.161.111.043-.278h.033l-.043.278Zm.12-.237.012-.041h.033l-.012.041Zm-.039.237.036-.2h.033l-.033.2Zm.084,0,.036-.2h.029l-.005.036a.057.057,0,0,1,.027-.029.066.066,0,0,1,.038-.012.069.069,0,0,1,.034.012l.017.029a.067.067,0,0,1,.063-.041.039.039,0,0,1,.038.017c.012.012.012.027.012.058l-.022.134h-.034l.024-.132V20.43l-.005-.01a.047.047,0,0,0-.031-.012.1.1,0,0,0-.033.015c-.009.007-.012.031-.017.048l-.024.117h-.027l.017-.132c.007-.009.007-.029,0-.033a.042.042,0,0,0-.029-.015.056.056,0,0,0-.027.012c-.005,0-.012.007-.015.027a.108.108,0,0,0-.017.039l-.012.1Zm.357-.237.005-.041h.031l-.007.041Zm-.039.237.033-.2h.031l-.031.2Zm.081-.009.034-.2h.033l-.007.027a.088.088,0,0,1,.069-.033c.007,0,.019.005.031.005s.016.012.016.024l.005.019v.039l-.027.122H590.5l.014-.122a.074.074,0,0,0,.007-.036l-.012-.01-.009-.012a.1.1,0,0,0-.048.015.083.083,0,0,0-.027.053l-.017.1Zm.333-.012a.217.217,0,0,0-.029.021.237.237,0,0,1-.039.007.073.073,0,0,1-.052-.019.07.07,0,0,1,0-.069.058.058,0,0,0,.024-.021.046.046,0,0,0,.028-.01h.027a.464.464,0,0,1,.058-.01c0-.01.007-.01.007-.01a.054.054,0,0,0-.007-.033.081.081,0,0,0-.033-.012c-.014,0-.026.009-.036.009a.053.053,0,0,0-.024.034l-.026-.007c0-.021.012-.027.017-.039a.126.126,0,0,1,.033-.017.1.1,0,0,1,.039-.007c.024,0,.036,0,.041.007l.022.015c.005.005.005.017.012.021s-.007.021-.007.029l-.005.051a.167.167,0,0,0-.012.06v.024h-.033a.037.037,0,0,1-.007-.024m.012-.072c-.012,0-.028.005-.053.005-.01,0-.022,0-.027.007s-.012.005-.016.012l-.005.015a.06.06,0,0,0,.005.026.049.049,0,0,0,.027.007.068.068,0,0,0,.036-.007c.005-.009.016-.014.021-.026s.012-.015.012-.034Zm.192.1.005-.024a.057.057,0,0,1-.057.027.054.054,0,0,1-.041-.015.07.07,0,0,1-.022-.039v-.053c.007-.021.012-.033.019-.057s.024-.022.036-.034a.055.055,0,0,1,.041-.012.057.057,0,0,1,.036.007c.009.005.009.017.016.021l.021-.1.031,0-.051.276Zm-.081-.1a.11.11,0,0,0,0,.053.05.05,0,0,0,.034.019.077.077,0,0,0,.045-.019.148.148,0,0,0,.021-.053.1.1,0,0,0,0-.065c-.012-.01-.017-.019-.036-.019a.057.057,0,0,0-.038.019.1.1,0,0,0-.024.057Zm.177-.009a.1.1,0,0,1,.041-.079.1.1,0,0,1,.065-.024.059.059,0,0,1,.058.036c.012.01.017.036.012.075a.156.156,0,0,1-.022.053.06.06,0,0,1-.036.031.092.092,0,0,1-.05.017.09.09,0,0,1-.06-.029.1.1,0,0,1-.009-.081m.029.009a.08.08,0,0,0,.007.053.044.044,0,0,0,.038.019.071.071,0,0,0,.045-.019.129.129,0,0,0,.027-.053.111.111,0,0,0-.005-.065.051.051,0,0,0-.039-.01c-.019-.009-.027,0-.045.01a.176.176,0,0,0-.027.065m.269.1.039-.2h.024v.031l.017-.019a.068.068,0,0,1,.022-.017.07.07,0,0,1,.038.017l-.014.031-.012-.012c-.024,0-.031,0-.034.012a.074.074,0,0,0-.017.017.141.141,0,0,0-.012.039l-.012.1Zm.266-.06.039.007a.111.111,0,0,1-.045.045c-.012.015-.033.017-.056.017a.064.064,0,0,1-.057-.033c-.019-.015-.019-.041-.012-.075a.2.2,0,0,1,.038-.077.112.112,0,0,1,.072-.027.074.074,0,0,1,.06.027.116.116,0,0,1,.007.084v.005l-.151-.005c0,.027,0,.041.012.053a.045.045,0,0,0,.036.019.092.092,0,0,0,.036-.009.181.181,0,0,0,.021-.031m-.092-.057.108,0a.113.113,0,0,0,0-.039.044.044,0,0,0-.038-.024.05.05,0,0,0-.039.015.111.111,0,0,0-.027.045m.159.057h.033c0,.012,0,.027.012.033s.015.007.031.007l.033,0c.012-.005.012-.012.017-.024l-.005-.017a.072.072,0,0,1-.034-.015.1.1,0,0,1-.041-.019c-.012,0-.019-.005-.021-.014v-.031a.054.054,0,0,1,.009-.026l.012-.01a.044.044,0,0,1,.031-.012l.029,0,.036,0a.085.085,0,0,0,.024.019.083.083,0,0,1,.005.029l-.033.01a.049.049,0,0,0-.005-.027.046.046,0,0,0-.027-.012c-.019,0-.029,0-.036.012s-.016.009-.016.017v.01c.007.005.007.01.016.01a.048.048,0,0,0,.024.01.162.162,0,0,0,.048.014l.017.019v.029c0,.015-.012.024-.017.031s-.016.021-.033.029a.123.123,0,0,1-.039,0,.062.062,0,0,1-.052-.017.076.076,0,0,1-.017-.055m.17.149.052-.281.033,0,0,.027a.047.047,0,0,1,.027-.019.051.051,0,0,1,.033-.012c.019,0,.027.012.046.015a.06.06,0,0,1,.021.043v.053a.226.226,0,0,1-.027.053.1.1,0,0,1-.039.036.063.063,0,0,1-.045.012.074.074,0,0,1-.026-.009c-.007,0-.019-.012-.019-.021l-.021.1Zm.064-.177a.089.089,0,0,0,.007.06.052.052,0,0,0,.033.019.045.045,0,0,0,.038-.015.128.128,0,0,0,.027-.063.091.091,0,0,0-.005-.057.032.032,0,0,0-.027-.017.1.1,0,0,0-.045.017.132.132,0,0,0-.027.057m.305.048.027.007c-.009.021-.015.039-.036.045a.083.083,0,0,1-.055.015c-.033,0-.057-.009-.065-.027a.12.12,0,0,1-.012-.081c.012-.033.021-.063.045-.072a.084.084,0,0,1,.072-.027.046.046,0,0,1,.051.034c.017.012.017.041.012.07v.01l-.147,0c0,.017,0,.039.012.048s.016.021.039.021a.039.039,0,0,0,.027-.009.1.1,0,0,0,.029-.031m-.1-.06.108.007a.053.053,0,0,0-.012-.041.031.031,0,0,0-.029-.019.434.434,0,0,0-.046.009.113.113,0,0,0-.021.045m.208-.11.005-.039h.033l-.009.039Zm-.048.237.041-.2.031,0-.039.206Zm.154-.021v.029l-.014,0-.036-.007c-.007-.009-.012-.012-.012-.021a.2.2,0,0,1,.005-.039l.021-.117h-.021l.007-.029.017,0,.012-.051.039-.021-.019.072h.036l-.005.026h-.031l-.026.12V20.6l.012.007Zm.156.012c-.017.005-.029.017-.041.021l-.039,0a.06.06,0,0,1-.045-.017.053.053,0,0,1-.007-.045c0-.007.007-.012.012-.027s.01-.012.022-.012l.026-.015h.024a.3.3,0,0,0,.063-.012v-.036a.206.206,0,0,0-.039-.021c-.017,0-.024.01-.029.01a.161.161,0,0,0-.027.033l-.029,0a.177.177,0,0,1,.017-.039.17.17,0,0,0,.039-.017c.012,0,.024-.009.041-.009a.069.069,0,0,1,.039.017l.021.009c0,.01.007.021.007.031a.058.058,0,0,0-.007.026l-.012.048c0,.031-.009.051-.009.058l.005.022h-.033Zm0-.079c0,.007-.027.009-.051.009s-.024,0-.024.012a.042.042,0,0,0-.021.007l-.005.009a.059.059,0,0,0,.005.033.046.046,0,0,0,.027.01.058.058,0,0,0,.029-.01.039.039,0,0,0,.031-.021.07.07,0,0,0,.008-.036Zm.177.009a.137.137,0,0,1,.051-.077.1.1,0,0,1,.065-.017c.024,0,.048,0,.057.029a.083.083,0,0,1,.012.069c-.005.027-.017.048-.021.067a.27.27,0,0,1-.045.033.077.077,0,0,1-.043.009.082.082,0,0,1-.065-.027.114.114,0,0,1-.012-.084m.039,0c-.007.027-.007.048.005.06a.044.044,0,0,0,.033.024.053.053,0,0,0,.043-.024.132.132,0,0,0,.033-.051.091.091,0,0,0-.007-.06c-.012-.014-.021-.024-.036-.024a.066.066,0,0,0-.045.022.081.081,0,0,0-.026.053m.25.185.06-.271h.027l-.007.029a.087.087,0,0,1,.031-.024.072.072,0,0,1,.036-.005.046.046,0,0,1,.038.017c0,.012.016.017.016.036a.072.072,0,0,1,0,.053.112.112,0,0,1-.021.055c-.012.021-.021.033-.036.038a.114.114,0,0,1-.051.012.045.045,0,0,1-.024-.012l-.014-.014-.027.089Zm.067-.17c-.007.027-.007.045,0,.057a.044.044,0,0,0,.031.027.086.086,0,0,0,.045-.019.1.1,0,0,0,.024-.06.088.088,0,0,0,0-.06.035.035,0,0,0-.031-.017.092.092,0,0,0-.045.012.107.107,0,0,0-.026.06m.153.113.046-.2h.026l-.007.031c.012-.012.021-.021.027-.021a.033.033,0,0,1,.027-.01c.012,0,.014.01.026.019l-.014.024-.012-.007c-.016,0-.027,0-.034.007l-.014.015a.088.088,0,0,0-.012.041l-.027.1-.033,0Zm.134-.093a.152.152,0,0,1,.045-.087.356.356,0,0,1,.067-.014.072.072,0,0,1,.06.033.123.123,0,0,1,.012.075.221.221,0,0,1-.031.058.077.077,0,0,1-.036.034.4.4,0,0,1-.048.009c-.029-.007-.05-.012-.062-.031a.11.11,0,0,1-.007-.077m.033,0a.078.078,0,0,0,.007.063.037.037,0,0,0,.033.014.043.043,0,0,0,.045-.014.126.126,0,0,0,.031-.057v-.06a.049.049,0,0,0-.043-.022.048.048,0,0,0-.041.022c-.019.005-.024.029-.031.053m.211-.122.017-.043h.027l-.007.043Zm-.1.31.007-.027.012,0a.071.071,0,0,0,.024-.005.1.1,0,0,1,.009-.036l.045-.211h.033l-.045.216c-.005.021-.009.043-.021.048a.042.042,0,0,1-.039.015.048.048,0,0,1-.024,0m.281-.125.034,0a.056.056,0,0,1-.039.043.085.085,0,0,1-.06.021.1.1,0,0,1-.06-.033.116.116,0,0,1-.009-.075.1.1,0,0,1,.045-.074.067.067,0,0,1,.069-.027c.027,0,.051.012.055.027s.017.045.005.084v.005l-.141-.005c0,.021,0,.034.012.046s.012.022.029.022a.042.042,0,0,0,.034-.007.044.044,0,0,0,.026-.029m-.089-.063.108.007a.055.055,0,0,0-.012-.043.035.035,0,0,0-.033-.017.047.047,0,0,0-.039.014.041.041,0,0,0-.024.039",
    transform: "translate(-554.173 14.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7094",
    "data-name": "Caminho 7094",
    d: "M591.323,20.593l.026,0a.079.079,0,0,1-.033.053.125.125,0,0,1-.06.015.064.064,0,0,1-.062-.036.1.1,0,0,1,0-.072.072.072,0,0,1,.027-.057.04.04,0,0,1,.033-.033.089.089,0,0,1,.05-.015.106.106,0,0,1,.048.021.066.066,0,0,1,.019.051l-.033,0a.047.047,0,0,0-.012-.031.031.031,0,0,0-.027-.015.055.055,0,0,0-.045.019.115.115,0,0,0-.027.057.116.116,0,0,0,0,.06.044.044,0,0,0,.039.019.082.082,0,0,0,.033-.014.046.046,0,0,0,.027-.029m.12.051v.029h-.024a.084.084,0,0,1-.034-.005s-.009-.009-.009-.015a.093.093,0,0,1,.007-.039l.026-.113-.024,0,.007-.029.024.005.009-.053.039-.015-.016.069h.033l-.005.031-.033,0-.027.117v.024l.009,0Zm.038-.063a.113.113,0,0,1,.043-.081.081.081,0,0,1,.065-.019.079.079,0,0,1,.063.031.1.1,0,0,1,0,.081.18.18,0,0,1-.022.057.1.1,0,0,1-.045.031.162.162,0,0,1-.051.012.124.124,0,0,1-.057-.036.069.069,0,0,1,0-.075m.034,0a.048.048,0,0,0,0,.057.057.057,0,0,0,.034.024.1.1,0,0,0,.046-.021.108.108,0,0,0,.026-.057.056.056,0,0,0,0-.055c-.012-.021-.021-.024-.038-.024a.066.066,0,0,0-.046.015.077.077,0,0,0-.022.06m.379.129.012-.021a.1.1,0,0,1-.064.024.1.1,0,0,1-.041-.015.187.187,0,0,1-.021-.036.081.081,0,0,1,.005-.055.224.224,0,0,1,.016-.057c.012-.014.031-.029.041-.041a.182.182,0,0,1,.043,0l.033,0c.009.012.009.021.021.029l.019-.1h.033l-.063.276Zm-.081-.1a.124.124,0,0,0,.007.055.037.037,0,0,0,.029.027.059.059,0,0,0,.039-.021c.017-.007.024-.027.029-.051a.2.2,0,0,0,0-.063.032.032,0,0,0-.033-.017.033.033,0,0,0-.039.012.2.2,0,0,0-.033.058m.312.062.032.009c-.015.017-.021.033-.045.045a.105.105,0,0,1-.06.012A.079.079,0,0,1,592,20.7a.154.154,0,0,1-.007-.079.148.148,0,0,1,.048-.07.07.07,0,0,1,.065-.024c.034,0,.046.014.055.033a.1.1,0,0,1,.012.081l-.007.009-.141-.021c-.005.027-.005.043.007.057s.017.021.029.021.027,0,.032-.005a.087.087,0,0,0,.034-.029m-.1-.062.108.007v-.036a.048.048,0,0,0-.079-.012c-.017.007-.021.024-.029.041m.47.063.029.019a.117.117,0,0,1-.053.062.149.149,0,0,1-.079.019.087.087,0,0,1-.062-.027.181.181,0,0,1-.031-.053.27.27,0,0,1,.007-.075.132.132,0,0,1,.038-.075.1.1,0,0,1,.055-.041.085.085,0,0,1,.065-.015.073.073,0,0,1,.06.027.1.1,0,0,1,.027.069l-.036,0c0-.024-.007-.039-.019-.045s-.021-.019-.038-.027a.137.137,0,0,0-.055.015.117.117,0,0,0-.041.041.122.122,0,0,0-.019.051.142.142,0,0,0,0,.06.059.059,0,0,0,.014.045c.016.005.028.017.043.017a.137.137,0,0,0,.057-.014.185.185,0,0,0,.041-.055Zm.062.01a.14.14,0,0,1,.052-.082.178.178,0,0,1,.065-.014.072.072,0,0,1,.058.11.228.228,0,0,1-.024.06.062.062,0,0,1-.039.027.072.072,0,0,1-.051.012c-.026-.007-.048-.015-.053-.033a.093.093,0,0,1-.007-.081m.034,0a.083.083,0,0,0,0,.058.044.044,0,0,0,.077.01c.021-.01.027-.027.039-.055a.1.1,0,0,0-.007-.057.029.029,0,0,0-.033-.024.087.087,0,0,0-.045.012.093.093,0,0,0-.033.055m.153.125.077-.276h.032l-.072.276Zm.209.017.009-.024a.09.09,0,0,1-.072.024l-.032-.005a.145.145,0,0,1-.012-.024v-.024a.112.112,0,0,1,0-.031l.033-.122.033,0-.033.108a.289.289,0,0,1-.007.039l.007.015a.016.016,0,0,0,.015.012.067.067,0,0,0,.033,0,.08.08,0,0,0,.029-.021l.016-.034.027-.113.036.007-.057.2Zm.072.012.053-.2.033,0-.012.027a.173.173,0,0,1,.034-.019.057.057,0,0,1,.038,0c.012,0,.021,0,.024.01s.012.014.019.033a.063.063,0,0,1,.065-.033c.024.005.032.009.039.024a.115.115,0,0,1,.005.046l-.038.141-.034-.005.034-.123a.089.089,0,0,0,.005-.033l-.005-.012-.012-.005a.062.062,0,0,0-.048.005.074.074,0,0,0-.024.045l-.031.115-.026,0,.033-.129c.005-.019.005-.027,0-.033s-.012-.019-.027-.021a.037.037,0,0,0-.024.009c-.012,0-.016.012-.021.021s-.012.024-.019.041l-.026.1Zm.338.045-.027,0,.069-.271.039,0-.032.093a.069.069,0,0,1,.06-.014.051.051,0,0,1,.032.009.032.032,0,0,1,.021.024c0,.012.007.021.007.033s-.007.027-.007.039a.156.156,0,0,1-.048.081.108.108,0,0,1-.065.021c-.024,0-.036-.017-.043-.039Zm.024-.1a.168.168,0,0,0,0,.055c0,.021.016.026.033.029a.043.043,0,0,0,.039-.012.1.1,0,0,0,.032-.057.059.059,0,0,0,0-.055.03.03,0,0,0-.026-.029.058.058,0,0,0-.043.017.084.084,0,0,0-.033.051m.274.123a.15.15,0,0,0-.038.017.141.141,0,0,1-.039,0,.105.105,0,0,1-.045-.027.045.045,0,0,1,0-.041.047.047,0,0,1,.015-.031.053.053,0,0,1,.024-.014s.016,0,.021-.01h.033a.172.172,0,0,0,.06-.005v-.012a.021.021,0,0,0,0-.027.042.042,0,0,0-.033-.015l-.033,0-.027.027-.027-.007c.007-.014.01-.024.022-.029a.125.125,0,0,1,.033-.021.242.242,0,0,1,.05,0c.012,0,.022.012.034.015s.014.014.014.014a.039.039,0,0,1,.007.027.049.049,0,0,1-.007.027l-.009.048a.266.266,0,0,0-.017.06v.029l-.034-.009Zm.019-.081a.5.5,0,0,1-.057,0,.039.039,0,0,0-.027.007l-.017.012,0,.009c-.007.012-.007.024,0,.027a.041.041,0,0,0,.028.017.037.037,0,0,0,.032-.012.027.027,0,0,0,.026-.015.214.214,0,0,0,.019-.034Zm.051.117.062-.2.027,0-.007.027a.079.079,0,0,1,.072-.021.047.047,0,0,1,.027.012l.016.017v.027a.047.047,0,0,1-.009.029l-.034.127h-.033l.036-.127a.146.146,0,0,1,.007-.029l-.01-.024-.012,0a.075.075,0,0,0-.041,0,.072.072,0,0,0-.033.051l-.033.113Zm.221-.07A.162.162,0,0,1,594,20.79a.134.134,0,0,1,.065-.009.091.091,0,0,1,.06.033.1.1,0,0,1,0,.084.126.126,0,0,1-.027.057.137.137,0,0,1-.045.027.084.084,0,0,1-.048.009.092.092,0,0,1-.053-.038.1.1,0,0,1,0-.082m.033.007a.076.076,0,0,0,0,.057c0,.019.015.021.033.031a.047.047,0,0,0,.043-.015.125.125,0,0,0,.032-.057c.012-.027.012-.048,0-.06a.037.037,0,0,0-.032-.024.053.053,0,0,0-.043.015c-.017,0-.027.026-.033.053",
    transform: "translate(-551.501 14.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7095",
    "data-name": "Caminho 7095",
    d: "M593.3,21.9a.04.04,0,0,1-.033-.012.066.066,0,0,1-.031-.093l.815-1.44a.067.067,0,0,1,.117.067l-.808,1.439a.064.064,0,0,1-.06.039",
    transform: "translate(-550.041 14.521)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7096",
    "data-name": "Caminho 7096",
    d: "M582.222,12.644c4.557-.063,25.613,12.875,25.678,15.257l-1.3,2.006c-.593-2.769-21.958-15.356-25.485-15.12Z",
    transform: "translate(-558.701 9.036)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7097",
    "data-name": "Caminho 7097",
    d: "M596.052,23.4l1.036-1.759a.042.042,0,0,1,.057-.015.039.039,0,0,1,.012.057Z",
    transform: "translate(-548.023 15.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7098",
    "data-name": "Caminho 7098",
    d: "M581.16,14.658l.948-1.951a.047.047,0,0,1,.063-.015.037.037,0,0,1,.015.055Z",
    transform: "translate(-558.666 9.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7099",
    "data-name": "Caminho 7099",
    d: "M581.111,14.8c.847-.571,7.066,2.2,13.57,6.132s12.7,8.383,12.14,9.218l-.183.288-.086.072c.017-.015.11-.129-.01-.434-.274-.916-4.677-4.429-11.973-8.839-7.117-4.245-13.043-6.807-13.642-6.075Zm27.047,13.345c.537-1.063-5.231-5.408-12.381-9.64-7.32-4.151-12.59-6.6-13.551-5.862l-.221.382c0,.021.012-.021.053-.06a.95.95,0,0,1,.595-.144c1.661.021,6.4,2.207,13.047,6.018,2.911,1.7,12.3,7.724,12.266,9.422,0,.141.007.171-.045.249Z",
    transform: "translate(-558.833 8.943)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7100",
    "data-name": "Caminho 7100",
    d: "M606.563,30.555l-.041-.057c-.012,0-.019,0-.012-.01s.093-.093-.022-.386c-.283-.933-4.935-4.566-11.958-8.813C588.513,17.7,582.961,15.1,581.319,15.1a.489.489,0,0,0-.374.108l.007-.017a.175.175,0,0,1,.017-.06l.089-.326a.669.669,0,0,1,.389-.1c1.655,0,7.479,2.723,13.24,6.207,5.849,3.542,11.908,7.79,12.184,9.038a.3.3,0,0,1-.031.24l-.185.293c-.009.005-.033.015-.053.027l-.033.045ZM581.319,15.014c1.656,0,7.227,2.606,13.256,6.207,7.138,4.312,11.7,7.882,12,8.854a.809.809,0,0,1,.058.291l.139-.225a.2.2,0,0,0,.021-.171c-.266-1.214-6.452-5.538-12.136-8.986-5.754-3.469-11.558-6.195-13.2-6.195a.615.615,0,0,0-.326.065l-.108.221a.511.511,0,0,1,.305-.062m26.609,13.515a.04.04,0,0,1-.021-.009v0l-.015-.051.007-.005-.027.041.027-.041a.437.437,0,0,0,.009-.132c.033-1.735-9.535-7.853-12.244-9.434-6.624-3.8-11.37-5.987-13.024-6.012a.9.9,0,0,0-.562.134h-.012a.669.669,0,0,1,.547-.221c1.7.027,6.456,2.22,13.095,6.025,1.917,1.116,12.33,7.611,12.285,9.46v.031l.113-.175c.5-.969-4.938-5.18-12.366-9.58-7.862-4.453-12.642-6.517-13.5-5.869l-.178.336c-.036.009-.112.039-.112.024l.228-.41a.828.828,0,0,1,.554-.149c2.049,0,8.232,3.256,13.057,5.994,6.459,3.824,12.992,8.52,12.4,9.693l-.214.333a.046.046,0,0,1-.039.021",
    transform: "translate(-558.819 8.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7101",
    "data-name": "Caminho 7101",
    d: "M583.827,23.419a8.985,8.985,0,0,0,8.885,8.9,8.919,8.919,0,0,0,8.913-8.889V11.543l-17.8-.017Z",
    transform: "translate(-556.76 8.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7102",
    "data-name": "Caminho 7102",
    d: "M592.732,32.375A9.016,9.016,0,0,1,583.8,23.43V11.537l17.846-.027.053,11.927a8.977,8.977,0,0,1-8.966,8.938M601.6,11.555l-17.75.031L583.9,23.43a8.848,8.848,0,0,0,17.7.007Z",
    transform: "translate(-556.78 8.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7103",
    "data-name": "Caminho 7103",
    d: "M584.026,23.268v.009a8.471,8.471,0,0,0,2.507,6,8.515,8.515,0,0,0,12.052.009,8.437,8.437,0,0,0,2.508-6V11.758H584.028Zm13.635-8.06V22.54l-.007.773a4.972,4.972,0,0,1-1.5,3.59,5.1,5.1,0,0,1-8.676-3.614V15.184Z",
    transform: "translate(-556.618 8.403)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7104",
    "data-name": "Caminho 7104",
    d: "M592.584,31.84A8.606,8.606,0,0,1,584,23.292l.01-11.519,17.1-.039.039,11.565a8.571,8.571,0,0,1-8.568,8.541m8.489-20.066-17.024.036.033,11.474a8.5,8.5,0,0,0,16.992.015ZM592.581,28.45a5.2,5.2,0,0,1-5.123-5.146V15.165l10.223.021.039,7.371,0,.775a4.394,4.394,0,0,1-.043.638,4.969,4.969,0,0,1-1.466,2.98,5.08,5.08,0,0,1-3.626,1.5m-5.046-13.208.005,8.062a5.046,5.046,0,0,0,8.614,3.592,4.981,4.981,0,0,0,1.451-2.937,5.473,5.473,0,0,0,.034-.628l.005-8.108Z",
    transform: "translate(-556.637 8.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7105",
    "data-name": "Caminho 7105",
    d: "M588.377,18.378h0a1.252,1.252,0,0,0,.329.856,1.1,1.1,0,0,0,.8.36,1.073,1.073,0,0,0,.794-.357,1.25,1.25,0,0,0,.334-.859v-1.61l-2.246,0Z",
    transform: "translate(-553.508 11.981)",
    fill: "#1a0095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7106",
    "data-name": "Caminho 7106",
    d: "M589.5,16.995a.221.221,0,1,0,0,.442.221.221,0,0,0,0-.442",
    transform: "translate(-552.869 12.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7107",
    "data-name": "Caminho 7107",
    d: "M589.133,17.343a.227.227,0,0,0-.221.228.223.223,0,0,0,.446,0,.227.227,0,0,0-.225-.228",
    transform: "translate(-553.126 12.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7108",
    "data-name": "Caminho 7108",
    d: "M589.5,17.706a.236.236,0,0,0-.23.228.229.229,0,0,0,.23.221.223.223,0,0,0,.221-.221.23.23,0,0,0-.221-.228",
    transform: "translate(-552.869 12.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7109",
    "data-name": "Caminho 7109",
    d: "M588.784,17.711a.22.22,0,0,0,0,.441.22.22,0,1,0,0-.441",
    transform: "translate(-553.373 12.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7110",
    "data-name": "Caminho 7110",
    d: "M588.787,16.995a.219.219,0,0,0-.225.216.225.225,0,1,0,.449,0,.219.219,0,0,0-.225-.216",
    transform: "translate(-553.376 12.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7111",
    "data-name": "Caminho 7111",
    d: "M588.372,20.637h0a1.237,1.237,0,0,0,.333.856,1.056,1.056,0,0,0,.79.353,1.07,1.07,0,0,0,.8-.353,1.229,1.229,0,0,0,.326-.852V19.027l-2.244-.007Z",
    transform: "translate(-553.512 13.592)",
    fill: "#1a0095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7112",
    "data-name": "Caminho 7112",
    d: "M589.489,19.252a.221.221,0,0,0,0,.442.221.221,0,1,0,0-.442",
    transform: "translate(-552.869 13.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7113",
    "data-name": "Caminho 7113",
    d: "M589.126,19.6a.22.22,0,1,0,.218.221.217.217,0,0,0-.218-.221",
    transform: "translate(-553.131 14.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7114",
    "data-name": "Caminho 7114",
    d: "M589.492,19.965a.227.227,0,0,0-.225.225.224.224,0,0,0,.225.218.218.218,0,0,0,.218-.218.221.221,0,0,0-.218-.225",
    transform: "translate(-552.872 14.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7115",
    "data-name": "Caminho 7115",
    d: "M588.777,19.965a.224.224,0,0,0-.218.225.226.226,0,0,0,.218.225.225.225,0,1,0,0-.449",
    transform: "translate(-553.378 14.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7116",
    "data-name": "Caminho 7116",
    d: "M588.78,19.251a.223.223,0,1,0,0,.446.223.223,0,1,0,0-.446",
    transform: "translate(-553.381 13.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7117",
    "data-name": "Caminho 7117",
    d: "M586.559,18.383h0a1.262,1.262,0,0,0,.333.852,1.065,1.065,0,0,0,.792.357,1.039,1.039,0,0,0,.79-.353,1.228,1.228,0,0,0,.334-.849V16.773l-2.244,0Z",
    transform: "translate(-554.807 11.984)",
    fill: "#1a0095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7118",
    "data-name": "Caminho 7118",
    d: "M587.679,17a.225.225,0,0,0-.221.225.221.221,0,0,0,.221.221.229.229,0,0,0,.228-.221.233.233,0,0,0-.228-.225",
    transform: "translate(-554.165 12.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7119",
    "data-name": "Caminho 7119",
    d: "M587.314,17.35a.219.219,0,1,0,0,.439.22.22,0,1,0,0-.439",
    transform: "translate(-554.426 12.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7120",
    "data-name": "Caminho 7120",
    d: "M587.679,17.715a.219.219,0,1,0,.221.221.223.223,0,0,0-.221-.221",
    transform: "translate(-554.165 12.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7121",
    "data-name": "Caminho 7121",
    d: "M586.968,17.715a.221.221,0,0,0-.221.221.224.224,0,0,0,.221.225.229.229,0,0,0,.225-.225.226.226,0,0,0-.225-.221",
    transform: "translate(-554.673 12.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7122",
    "data-name": "Caminho 7122",
    d: "M586.963,17a.222.222,0,0,0-.216.221.22.22,0,1,0,.441,0,.224.224,0,0,0-.225-.221",
    transform: "translate(-554.673 12.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7123",
    "data-name": "Caminho 7123",
    d: "M590.2,18.383h0a1.24,1.24,0,0,0,.326.852,1.087,1.087,0,0,0,.8.357,1.059,1.059,0,0,0,.792-.357,1.216,1.216,0,0,0,.333-.852V16.77H590.2l-.01,1.613Z",
    transform: "translate(-552.213 11.984)",
    fill: "#1a0095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7124",
    "data-name": "Caminho 7124",
    d: "M591.316,17a.219.219,0,0,0-.228.221.223.223,0,1,0,.446,0,.217.217,0,0,0-.218-.221",
    transform: "translate(-551.571 12.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7125",
    "data-name": "Caminho 7125",
    d: "M590.948,17.348a.221.221,0,1,0,.228.221.229.229,0,0,0-.228-.221",
    transform: "translate(-551.832 12.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7126",
    "data-name": "Caminho 7126",
    d: "M591.309,17.711a.222.222,0,0,0-.221.228.218.218,0,0,0,.221.218.222.222,0,0,0,.225-.218.226.226,0,0,0-.225-.228",
    transform: "translate(-551.571 12.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7127",
    "data-name": "Caminho 7127",
    d: "M590.6,17.715a.22.22,0,1,0,0,.439.219.219,0,0,0,0-.439",
    transform: "translate(-552.078 12.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7128",
    "data-name": "Caminho 7128",
    d: "M590.6,17a.225.225,0,0,0-.228.221.232.232,0,0,0,.228.225.225.225,0,0,0,.221-.225A.218.218,0,0,0,590.6,17",
    transform: "translate(-552.08 12.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7129",
    "data-name": "Caminho 7129",
    d: "M588.377,16.11h0a1.243,1.243,0,0,0,.329.847,1.1,1.1,0,0,0,.8.357,1.061,1.061,0,0,0,.794-.357,1.263,1.263,0,0,0,.334-.847V14.491h-2.253Z",
    transform: "translate(-553.508 10.356)",
    fill: "#1a0095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7130",
    "data-name": "Caminho 7130",
    d: "M589.5,14.718a.23.23,0,0,0-.228.228.224.224,0,0,0,.228.214.219.219,0,0,0,.221-.214.225.225,0,0,0-.221-.228",
    transform: "translate(-552.869 10.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7131",
    "data-name": "Caminho 7131",
    d: "M589.133,15.07a.219.219,0,0,0-.221.218.22.22,0,1,0,.439,0,.217.217,0,0,0-.218-.218",
    transform: "translate(-553.126 10.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7132",
    "data-name": "Caminho 7132",
    d: "M589.5,15.435a.225.225,0,0,0-.225.216.23.23,0,0,0,.225.226.228.228,0,0,0,.228-.226.222.222,0,0,0-.228-.216",
    transform: "translate(-552.869 11.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7133",
    "data-name": "Caminho 7133",
    d: "M588.784,15.435a.221.221,0,0,0,0,.442.221.221,0,1,0,0-.442",
    transform: "translate(-553.373 11.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7134",
    "data-name": "Caminho 7134",
    d: "M588.787,14.718a.224.224,0,0,0-.225.228.225.225,0,0,0,.449,0,.224.224,0,0,0-.225-.228",
    transform: "translate(-553.376 10.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7135",
    "data-name": "Caminho 7135",
    d: "M584.668,13.941a1.055,1.055,0,0,1,.607-1.029,1.026,1.026,0,0,1,.641,1.032Z",
    transform: "translate(-556.159 9.227)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7136",
    "data-name": "Caminho 7136",
    d: "M584.414,12.926l-.1.952h.621a.832.832,0,0,1,.6-.91.9.9,0,0,1,.621.91h.624l-.122-.96Z",
    transform: "translate(-556.412 9.231)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7137",
    "data-name": "Caminho 7137",
    d: "M586.821,13.929h-.662a1,1,0,0,0-.619-.919.82.82,0,0,0-.566.88l-.662.034.063-.994,2.286-.033Zm-1.344-.972-1.063.017-.065.916.586-.036a.815.815,0,0,1,.542-.9m.12,0a.971.971,0,0,1,.6.936l.538-.033-.108-.921Z",
    transform: "translate(-556.413 9.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7138",
    "data-name": "Caminho 7138",
    d: "M584.33,13.477h2.536a.113.113,0,0,1,.1.122.11.11,0,0,1-.1.118H584.33a.111.111,0,0,1-.1-.118.115.115,0,0,1,.1-.122",
    transform: "translate(-556.471 9.631)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7139",
    "data-name": "Caminho 7139",
    d: "M586.884,13.766h-2.536a.155.155,0,0,1,0-.309h2.536a.155.155,0,0,1,0,.309m-2.536-.237v.156h2.536a.066.066,0,0,0,.062-.072Z",
    transform: "translate(-556.488 9.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7140",
    "data-name": "Caminho 7140",
    d: "M584.827,13.744a.658.658,0,0,1,.334-.641.667.667,0,0,1,.353.641Z",
    transform: "translate(-556.045 9.364)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7141",
    "data-name": "Caminho 7141",
    d: "M585.554,13.792h-.725a.658.658,0,0,1,.326-.71.666.666,0,0,1,.4.677Zm-.4-.638a.662.662,0,0,0-.29.605l.621-.036a.633.633,0,0,0-.331-.569",
    transform: "translate(-556.046 9.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7142",
    "data-name": "Caminho 7142",
    d: "M584.359,12.691H586.8a.1.1,0,0,1,.093.108.1.1,0,0,1-.093.1h-2.437a.1.1,0,0,1-.1-.1.1.1,0,0,1,.1-.108",
    transform: "translate(-556.448 9.069)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7143",
    "data-name": "Caminho 7143",
    d: "M586.811,12.948h-2.437a.131.131,0,0,1-.134-.135.133.133,0,0,1,.134-.141h2.437a.131.131,0,0,1,.129.141.129.129,0,0,1-.129.135m-2.437-.2v.132h2.437a.058.058,0,0,0,.053-.063Z",
    transform: "translate(-556.464 9.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7144",
    "data-name": "Caminho 7144",
    d: "M584.385,12.813h2.328a.11.11,0,0,1,0,.216h-2.328a.11.11,0,0,1,0-.216",
    transform: "translate(-556.423 9.157)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7145",
    "data-name": "Caminho 7145",
    d: "M586.73,13.084H584.4a.148.148,0,0,1,0-.293h2.328a.148.148,0,0,1,0,.293m-2.328-.221v.144h2.328c.028,0,.052-.033.052-.069Z",
    transform: "translate(-556.439 9.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7146",
    "data-name": "Caminho 7146",
    d: "M584.787,11.888h.185v.132h.135v-.132h.189v.132h.134v-.132h.185v.3a.08.08,0,0,1-.082.079h-.662a.09.09,0,0,1-.084-.081Z",
    transform: "translate(-556.074 8.496)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7147",
    "data-name": "Caminho 7147",
    d: "M585.549,12.318h-.693l-.093-.113v-.3l.225-.041.036.173.1-.043-.039-.089.228-.041.038.173.1-.043-.039-.089.225-.041.039.382Zm-.593-.413-.153.036.04.264.706.081.05-.079v-.3l-.153.036.039.1-.173.039-.039-.171-.149.036.038.1-.173.039Z",
    transform: "translate(-556.09 8.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7148",
    "data-name": "Caminho 7148",
    d: "M585.446,12.126l.044.97h-.655l.051-.976Z",
    transform: "translate(-556.039 8.662)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7149",
    "data-name": "Caminho 7149",
    d: "M585.527,13.143h-.691l.012-1.008.6-.034Zm-.12-1-.521.031-.009.94.569-.039Z",
    transform: "translate(-556.039 8.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7150",
    "data-name": "Caminho 7150",
    d: "M585.255,12.165h.18v.129h.13v-.132h.187v.132h.132v-.132h.178v.3a.081.081,0,0,1-.081.084h-.643a.086.086,0,0,1-.084-.084Z",
    transform: "translate(-555.739 8.691)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7151",
    "data-name": "Caminho 7151",
    d: "M586,12.594h-.682l-.084-.117v-.3l.219-.039.038.168.093-.036-.036-.1.223-.038.038.17.094-.036-.038-.1.216-.038.039.377Zm-.586-.413-.141.039.039.257.688.084.048-.084v-.3l-.146.039.033.093-.165.039-.039-.171-.147.039.034.093-.165.039Z",
    transform: "translate(-555.756 8.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7152",
    "data-name": "Caminho 7152",
    d: "M585.909,12.386l.021.521h-.619l.017-.521Z",
    transform: "translate(-555.7 8.851)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7153",
    "data-name": "Caminho 7153",
    d: "M585.977,12.958h-.659L585.3,12.4l.617-.036Zm-.1-.554-.542.033.021.489.542-.039Z",
    transform: "translate(-555.707 8.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7154",
    "data-name": "Caminho 7154",
    d: "M584.326,12.165h.183V12.3h.13v-.135l.187,0V12.3h.13v-.135h.187v.3a.084.084,0,0,1-.091.084h-.643a.09.09,0,0,1-.084-.084Z",
    transform: "translate(-556.403 8.691)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7155",
    "data-name": "Caminho 7155",
    d: "M585.07,12.594h-.684l-.081-.117v-.3l.219-.038.038.17.094-.036-.039-.1.224-.034.036.17.1-.036-.039-.1.225-.038.033.377Zm-.585-.41-.144.036.033.257.7.084.05-.084v-.3l-.146.039.038.1-.17.039-.039-.171-.146.036.034.1-.166.039Z",
    transform: "translate(-556.418 8.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7156",
    "data-name": "Caminho 7156",
    d: "M584.978,12.386l.019.521h-.61l.014-.521Z",
    transform: "translate(-556.36 8.851)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7157",
    "data-name": "Caminho 7157",
    d: "M585.052,12.964H584.4l-.024-.568.617-.036Zm-.1-.559-.542.033.019.489.543-.031Z",
    transform: "translate(-556.371 8.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7158",
    "data-name": "Caminho 7158",
    d: "M584.991,12.335a.063.063,0,1,1,.123,0v.228h-.123Z",
    transform: "translate(-555.928 8.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7159",
    "data-name": "Caminho 7159",
    d: "M585.456,12.524a.06.06,0,1,1,.12,0V12.7h-.12Z",
    transform: "translate(-555.596 8.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7160",
    "data-name": "Caminho 7160",
    d: "M584.523,12.524a.064.064,0,1,1,.129,0v.182h-.129Z",
    transform: "translate(-556.262 8.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7161",
    "data-name": "Caminho 7161",
    d: "M588.782,11.888h.189v.132h.129v-.132h.192v.132h.137v-.132h.185v.3a.079.079,0,0,1-.081.079h-.664a.088.088,0,0,1-.087-.079Z",
    transform: "translate(-553.219 8.496)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7162",
    "data-name": "Caminho 7162",
    d: "M589.549,12.322h-.7l-.089-.115v-.3l.226-.041.036.173.093-.039-.038-.093.23-.041.039.173.1-.039-.038-.093.225-.041.038.382Zm-.6-.417-.147.036.039.266.712.079.043-.079v-.3l-.147.036.034.1-.172.039-.039-.171-.153.036.039.1-.168.039Z",
    transform: "translate(-553.235 8.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7163",
    "data-name": "Caminho 7163",
    d: "M589.438,12.124l.039.97h-.641l.045-.97Z",
    transform: "translate(-553.18 8.664)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7164",
    "data-name": "Caminho 7164",
    d: "M589.513,13.141h-.676l.005-1.008.6-.027Zm-.113-1-.518.036-.012.934.569-.039Z",
    transform: "translate(-553.18 8.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7165",
    "data-name": "Caminho 7165",
    d: "M589.252,12.165h.173v.129h.135v-.132h.182v.132h.129v-.132h.189v.3a.077.077,0,0,1-.077.084h-.65a.083.083,0,0,1-.081-.084Z",
    transform: "translate(-552.883 8.691)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7166",
    "data-name": "Caminho 7166",
    d: "M590,12.594h-.686l-.084-.117v-.3l.216-.039.039.171.1-.036-.036-.1.218-.038.039.173.089-.036-.036-.1.225-.038.036.377Zm-.587-.413-.141.039.032.257.695.084.048-.084v-.3l-.156.039.039.1-.168.039-.036-.175-.146.039.036.1-.171.039Z",
    transform: "translate(-552.901 8.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7167",
    "data-name": "Caminho 7167",
    d: "M589.908,12.386l.021.521h-.622l.019-.521Z",
    transform: "translate(-552.844 8.851)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7168",
    "data-name": "Caminho 7168",
    d: "M589.286,12.964l.019-.568.616-.036.06.566Zm.593-.559-.542.033.021.449h.585Z",
    transform: "translate(-552.859 8.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7169",
    "data-name": "Caminho 7169",
    d: "M588.325,12.167h.18V12.3h.13v-.132h.18V12.3h.129v-.132h.192l0,.305a.074.074,0,0,1-.077.075h-.65a.086.086,0,0,1-.081-.084Z",
    transform: "translate(-553.545 8.693)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7170",
    "data-name": "Caminho 7170",
    d: "M589.072,12.593h-.686l-.084-.117v-.293l.219-.041.029.17.1-.036-.038-.1.218-.038.039.17.089-.036-.036-.1.225-.038.039.374Zm-.59-.41-.141.036.039.257.691.084.038-.075V12.18l-.149.039.043.093-.172.039-.039-.171-.141.039.039.093-.17.039Z",
    transform: "translate(-553.562 8.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7171",
    "data-name": "Caminho 7171",
    d: "M588.982,12.386l.015.521h-.621l.019-.521Z",
    transform: "translate(-553.508 8.851)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7172",
    "data-name": "Caminho 7172",
    d: "M589.038,12.961h-.655l-.016-.559.621-.039Zm-.089-.559-.542.033.016.489.542-.031Z",
    transform: "translate(-553.515 8.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7173",
    "data-name": "Caminho 7173",
    d: "M588.666,13.941a.7.7,0,1,1,1.238.009Z",
    transform: "translate(-553.302 9.227)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7174",
    "data-name": "Caminho 7174",
    d: "M588.413,12.926l-.1.952h.622a.835.835,0,0,1,.607-.91.911.911,0,0,1,.617.91h.616l-.108-.96Z",
    transform: "translate(-553.558 9.231)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7175",
    "data-name": "Caminho 7175",
    d: "M590.816,13.929h-.662a.979.979,0,0,0-.619-.919.835.835,0,0,0-.571.88l-.658.039.07-.993,2.287-.039Zm-1.349-.972-1.054.024-.072.909.585-.036a.832.832,0,0,1,.542-.9m.125,0a.972.972,0,0,1,.605.936l.538-.033-.111-.921Z",
    transform: "translate(-553.559 9.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7176",
    "data-name": "Caminho 7176",
    d: "M588.318,13.477h2.545c.053,0,.1.06.1.122a.108.108,0,0,1-.1.118h-2.545c-.048,0-.089-.051-.089-.118s.041-.122.089-.122",
    transform: "translate(-553.614 9.631)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7177",
    "data-name": "Caminho 7177",
    d: "M590.879,13.769h-2.545a.146.146,0,0,1-.129-.156.143.143,0,0,1,.129-.156h2.545a.144.144,0,0,1,.134.156.148.148,0,0,1-.134.156m-2.545-.24v.165h2.545c.032,0,.058-.036.058-.081Z",
    transform: "translate(-553.63 9.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7178",
    "data-name": "Caminho 7178",
    d: "M588.824,13.744a.658.658,0,0,1,.336-.641.676.676,0,0,1,.355.641Z",
    transform: "translate(-553.189 9.364)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7179",
    "data-name": "Caminho 7179",
    d: "M589.554,13.8h-.729a.443.443,0,1,1,.729-.038Zm-.4-.643a.677.677,0,0,0-.285.605l.614-.034a.624.624,0,0,0-.329-.571",
    transform: "translate(-553.19 9.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7180",
    "data-name": "Caminho 7180",
    d: "M588.359,12.691h2.43a.1.1,0,0,1,.094.108.1.1,0,0,1-.094.1h-2.43a.1.1,0,0,1-.1-.1.1.1,0,0,1,.1-.108",
    transform: "translate(-553.592 9.069)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7181",
    "data-name": "Caminho 7181",
    d: "M590.805,12.953h-2.437a.134.134,0,0,1-.129-.141.131.131,0,0,1,.129-.141h2.437a.133.133,0,0,1,.132.141.136.136,0,0,1-.132.141m-2.437-.209v.135h2.437a.067.067,0,0,0,.057-.067Z",
    transform: "translate(-553.606 9.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7182",
    "data-name": "Caminho 7182",
    d: "M588.388,12.813h2.325a.1.1,0,0,1,.088.111.1.1,0,0,1-.088.1h-2.325a.1.1,0,0,1-.1-.1.1.1,0,0,1,.1-.111",
    transform: "translate(-553.569 9.157)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7183",
    "data-name": "Caminho 7183",
    d: "M590.729,13.083H588.4a.144.144,0,0,1-.134-.144.143.143,0,0,1,.134-.147h2.325a.147.147,0,0,1,0,.291m-2.325-.216V13h2.325c.031,0,.048-.026.048-.065Z",
    transform: "translate(-553.585 9.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7184",
    "data-name": "Caminho 7184",
    d: "M588.99,12.334c-.012-.1.125-.1.125,0v.23h-.125Z",
    transform: "translate(-553.07 8.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7185",
    "data-name": "Caminho 7185",
    d: "M589.453,12.524a.06.06,0,1,1,.12,0v.182h-.12Z",
    transform: "translate(-552.739 8.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7186",
    "data-name": "Caminho 7186",
    d: "M588.522,12.525a.06.06,0,1,1,.12,0v.18h-.12Z",
    transform: "translate(-553.405 8.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7187",
    "data-name": "Caminho 7187",
    d: "M592.736,11.893h.185v.129h.132V11.89h.192v.132h.129V11.89h.185v.3a.072.072,0,0,1-.077.075h-.662a.082.082,0,0,1-.084-.075Z",
    transform: "translate(-550.393 8.497)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7188",
    "data-name": "Caminho 7188",
    d: "M593.5,12.322h-.7l-.086-.115v-.3l.225-.041.029.17.1-.033-.036-.1.228-.038.039.17.089-.033-.039-.1.225-.038.039.376Zm-.6-.413-.147.033.036.266.71.075.045-.075v-.3l-.153.036.039.1-.168.041-.039-.173-.153.036.036.1-.166.041Z",
    transform: "translate(-550.41 8.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7189",
    "data-name": "Caminho 7189",
    d: "M593.393,12.124l.041.972-.646,0,.039-.97Z",
    transform: "translate(-550.356 8.664)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7190",
    "data-name": "Caminho 7190",
    d: "M593.474,13.149l-.686,0V12.138l.605-.033Zm-.12-1.012-.526.041v.931l.566-.033Z",
    transform: "translate(-550.356 8.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7191",
    "data-name": "Caminho 7191",
    d: "M593.2,12.171h.185V12.3h.127v-.134h.185V12.3h.132v-.134h.185v.3a.075.075,0,0,1-.075.077h-.652a.083.083,0,0,1-.082-.077Z",
    transform: "translate(-550.062 8.694)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7192",
    "data-name": "Caminho 7192",
    d: "M593.954,12.6h-.689l-.084-.117v-.3l.219-.041.033.17.093-.041-.039-.093.225-.043.039.177.093-.041-.033-.093.218-.043.039.381Zm-.593-.413-.146.033.038.264.7.077.036-.077v-.3l-.147.036.039.1-.172.033-.038-.166-.147.036.039.1-.165.033Z",
    transform: "translate(-550.075 8.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7193",
    "data-name": "Caminho 7193",
    d: "M593.859,12.387l.021.521h-.622l.015-.521Z",
    transform: "translate(-550.021 8.853)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7194",
    "data-name": "Caminho 7194",
    d: "M593.919,12.963h-.655l-.015-.562.617-.038Zm-.093-.559-.542.039.019.482.538-.033Z",
    transform: "translate(-550.026 8.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7195",
    "data-name": "Caminho 7195",
    d: "M592.275,12.169h.177V12.3h.137v-.129h.177V12.3h.141v-.129h.18v.3a.083.083,0,0,1-.084.084h-.643a.089.089,0,0,1-.084-.084Z",
    transform: "translate(-550.723 8.696)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7196",
    "data-name": "Caminho 7196",
    d: "M593.017,12.6h-.681l-.082-.117v-.3l.213-.039.039.168.1-.039-.039-.089.216-.041.038.17.1-.039-.039-.089.218-.041.036.374Zm-.583-.413-.144.036.039.261.688.084.046-.084v-.3l-.141.033.034.1-.175.036-.036-.165-.141.033.029.1-.168.036Z",
    transform: "translate(-550.738 8.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7197",
    "data-name": "Caminho 7197",
    d: "M592.93,12.391l.024.518h-.622l.021-.518Z",
    transform: "translate(-550.682 8.855)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7198",
    "data-name": "Caminho 7198",
    d: "M593,12.965h-.662l-.024-.561.622-.041Zm-.1-.554-.542.033.019.485.538-.036Z",
    transform: "translate(-550.693 8.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7199",
    "data-name": "Caminho 7199",
    d: "M592.614,13.94a1.044,1.044,0,0,1,.61-1.024,1.025,1.025,0,0,1,.635,1.032Z",
    transform: "translate(-550.48 9.23)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7200",
    "data-name": "Caminho 7200",
    d: "M592.357,12.922l-.1.958h.617a.855.855,0,0,1,.61-.917.916.916,0,0,1,.614.917h.622l-.108-.958Z",
    transform: "translate(-550.733 9.234)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7201",
    "data-name": "Caminho 7201",
    d: "M594.768,13.926H594.1a.972.972,0,0,0-.614-.912.813.813,0,0,0-.571.88l-.655.033.062-.991,2.292-.034Zm-1.349-.967-1.061.019-.06.916.579-.039a.829.829,0,0,1,.542-.9m.12-.005a.955.955,0,0,1,.6.934l.542-.031-.1-.922Z",
    transform: "translate(-550.733 9.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7202",
    "data-name": "Caminho 7202",
    d: "M592.275,13.48h2.541a.111.111,0,0,1,.1.12.109.109,0,0,1-.1.117h-2.541a.105.105,0,0,1-.1-.117.107.107,0,0,1,.1-.12",
    transform: "translate(-550.791 9.633)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7203",
    "data-name": "Caminho 7203",
    d: "M594.831,13.771H592.29a.144.144,0,0,1-.132-.156.142.142,0,0,1,.132-.156h2.541a.147.147,0,0,1,.137.156.149.149,0,0,1-.137.156m-2.541-.24V13.7h2.541c.029,0,.06-.043.06-.084Z",
    transform: "translate(-550.806 9.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7204",
    "data-name": "Caminho 7204",
    d: "M592.772,13.74a.651.651,0,0,1,.338-.631.658.658,0,0,1,.362.631Z",
    transform: "translate(-550.367 9.368)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7205",
    "data-name": "Caminho 7205",
    d: "M593.507,13.794h-.734c-.032-.55.312-.706.329-.706a.649.649,0,0,1,.4.672Zm-.4-.638a.69.69,0,0,0-.29.6l.616-.029a.623.623,0,0,0-.326-.569",
    transform: "translate(-550.368 9.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7206",
    "data-name": "Caminho 7206",
    d: "M592.308,12.693h2.437a.1.1,0,0,1,.089.111.1.1,0,0,1-.089.1h-2.437a.1.1,0,0,1-.1-.1.107.107,0,0,1,.1-.111",
    transform: "translate(-550.768 9.071)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7207",
    "data-name": "Caminho 7207",
    d: "M594.76,12.957h-2.437a.137.137,0,0,1-.134-.137.142.142,0,0,1,.134-.147h2.437a.134.134,0,0,1,.122.147.128.128,0,0,1-.122.137m-2.437-.209v.137h2.437a.06.06,0,0,0,.053-.065Z",
    transform: "translate(-550.783 9.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7208",
    "data-name": "Caminho 7208",
    d: "M592.33,12.817h2.334a.1.1,0,0,1,.091.1.1.1,0,0,1-.091.1H592.33a.1.1,0,0,1-.088-.1.1.1,0,0,1,.088-.1",
    transform: "translate(-550.745 9.159)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7209",
    "data-name": "Caminho 7209",
    d: "M594.679,13.081h-2.334a.137.137,0,0,1-.124-.144.131.131,0,0,1,.124-.141h2.334a.131.131,0,0,1,.127.141.138.138,0,0,1-.127.144m-2.334-.213V13h2.334c.027,0,.051-.026.051-.065Z",
    transform: "translate(-550.76 9.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7210",
    "data-name": "Caminho 7210",
    d: "M592.937,12.333a.068.068,0,1,1,.135,0v.237h-.135Z",
    transform: "translate(-550.25 8.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7211",
    "data-name": "Caminho 7211",
    d: "M593.4,12.53a.063.063,0,1,1,.125,0V12.7H593.4Z",
    transform: "translate(-549.918 8.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7212",
    "data-name": "Caminho 7212",
    d: "M592.471,12.53a.065.065,0,1,1,.13,0v.177h-.13Z",
    transform: "translate(-550.582 8.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7213",
    "data-name": "Caminho 7213",
    d: "M584.794,15.94h.173v.135h.135v-.139h.194v.139h.129v-.139h.192v.3a.08.08,0,0,1-.089.074h-.662a.075.075,0,0,1-.072-.074Z",
    transform: "translate(-556.069 11.389)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7214",
    "data-name": "Caminho 7214",
    d: "M585.546,16.365h-.693l-.084-.11v-.3l.216-.039.036.175.1-.036-.034-.1.228-.036.033.175.1-.036-.033-.1.225-.036.033.376Zm-.593-.41-.141.033.033.267.7.074.05-.074v-.3l-.153.036.039.1-.168.029-.041-.168-.153.036.038.1-.173.029Z",
    transform: "translate(-556.087 11.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7215",
    "data-name": "Caminho 7215",
    d: "M585.441,16.173l.048.97-.646,0,.039-.967h.559Z",
    transform: "translate(-556.034 11.558)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7216",
    "data-name": "Caminho 7216",
    d: "M585.525,17.193l-.682,0v-1l.6-.036Zm-.117-1-.526.036v.934l.571-.034Z",
    transform: "translate(-556.034 11.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7217",
    "data-name": "Caminho 7217",
    d: "M585.258,16.213h.173v.135h.132v-.135h.185v.135h.132v-.135h.185v.305a.075.075,0,0,1-.081.072h-.646a.079.079,0,0,1-.081-.072Z",
    transform: "translate(-555.737 11.586)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7218",
    "data-name": "Caminho 7218",
    d: "M586,16.641h-.679l-.087-.108v-.305l.213-.033.039.168.093-.039-.033-.1.218-.036.039.171.093-.039-.029-.1.214-.036.033.374Zm-.586-.413-.141.036.033.269.695.072.048-.072v-.305l-.153.036.033.1-.165.036-.033-.171-.153.036.039.1-.171.036Z",
    transform: "translate(-555.754 11.571)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7219",
    "data-name": "Caminho 7219",
    d: "M585.916,16.434l.021.523h-.626l.019-.523Z",
    transform: "translate(-555.7 11.744)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7220",
    "data-name": "Caminho 7220",
    d: "M585.974,17.006h-.658l-.012-.557.617-.036Zm-.093-.557-.547.036.021.487.547-.033Z",
    transform: "translate(-555.704 11.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7221",
    "data-name": "Caminho 7221",
    d: "M584.33,16.223h.177v.125h.137v-.134h.18v.134h.132v-.134h.185v.305a.078.078,0,0,1-.084.074h-.643a.083.083,0,0,1-.084-.074Z",
    transform: "translate(-556.4 11.587)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7222",
    "data-name": "Caminho 7222",
    d: "M585.076,16.646h-.682l-.081-.113v-.3l.206-.041.039.166.1-.033-.038-.1.218-.033.036.166.1-.033-.039-.1.218-.033.033.374Zm-.59-.41-.144.027.033.269.7.074.045-.074v-.305l-.146.036.033.1-.172.039-.033-.173-.147.036.031.1-.168.039Z",
    transform: "translate(-556.412 11.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7223",
    "data-name": "Caminho 7223",
    d: "M584.984,16.435l.024.523h-.622l.014-.523Z",
    transform: "translate(-556.361 11.745)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7224",
    "data-name": "Caminho 7224",
    d: "M585.049,17.007h-.657l-.017-.561.617-.033Zm-.087-.557-.554.039.024.484.542-.033Z",
    transform: "translate(-556.368 11.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7225",
    "data-name": "Caminho 7225",
    d: "M584.668,17.991a1.044,1.044,0,0,1,.607-1.027A1.025,1.025,0,0,1,585.916,18Z",
    transform: "translate(-556.159 12.123)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7226",
    "data-name": "Caminho 7226",
    d: "M584.417,16.975l-.1.955h.616a.849.849,0,0,1,.61-.916.908.908,0,0,1,.614.916h.622l-.108-.96Z",
    transform: "translate(-556.41 12.127)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7227",
    "data-name": "Caminho 7227",
    d: "M586.823,17.979h-.667a.957.957,0,0,0-.619-.916.816.816,0,0,0-.566.883l-.655.033.062-.993,2.293-.039Zm-1.349-.972-1.056.021-.072.922.586-.045a.827.827,0,0,1,.542-.9m.12,0a.955.955,0,0,1,.6.934l.538-.034-.1-.917Z",
    transform: "translate(-556.41 12.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7228",
    "data-name": "Caminho 7228",
    d: "M584.33,17.53h2.541a.11.11,0,0,1,.1.117.112.112,0,0,1-.1.12H584.33a.111.111,0,0,1-.1-.12.108.108,0,0,1,.1-.117",
    transform: "translate(-556.471 12.528)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7229",
    "data-name": "Caminho 7229",
    d: "M586.887,17.819h-2.541a.149.149,0,0,1-.137-.156.152.152,0,0,1,.137-.156h2.541a.149.149,0,0,1,.137.156.147.147,0,0,1-.137.156m-2.541-.24v.161h2.541a.069.069,0,0,0,.06-.077Z",
    transform: "translate(-556.487 12.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7230",
    "data-name": "Caminho 7230",
    d: "M584.827,17.793a.668.668,0,0,1,.345-.641.685.685,0,0,1,.355.641Z",
    transform: "translate(-556.045 12.257)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7231",
    "data-name": "Caminho 7231",
    d: "M585.567,17.846h-.739c-.029-.55.309-.713.345-.713a.688.688,0,0,1,.389.681Zm-.41-.638a.67.67,0,0,0-.29.6l.626-.033a.626.626,0,0,0-.336-.566",
    transform: "translate(-556.046 12.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7232",
    "data-name": "Caminho 7232",
    d: "M584.359,16.741H586.8a.1.1,0,0,1,.089.1.1.1,0,0,1-.089.108h-2.437a.1.1,0,0,1-.093-.108.1.1,0,0,1,.093-.1",
    transform: "translate(-556.445 11.964)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7233",
    "data-name": "Caminho 7233",
    d: "M586.813,17.007h-2.437a.137.137,0,0,1-.132-.147.134.134,0,0,1,.132-.141h2.437a.132.132,0,0,1,.125.141.137.137,0,0,1-.125.147m-2.437-.213v.132h2.437a.062.062,0,0,0,.057-.067Z",
    transform: "translate(-556.462 11.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7234",
    "data-name": "Caminho 7234",
    d: "M584.391,16.865h2.322a.1.1,0,0,1,.094.108.1.1,0,0,1-.094.1h-2.322a.1.1,0,0,1-.093-.1.1.1,0,0,1,.093-.108",
    transform: "translate(-556.423 12.052)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7235",
    "data-name": "Caminho 7235",
    d: "M586.729,17.133h-2.322a.143.143,0,0,1-.132-.144.148.148,0,0,1,.132-.149h2.322a.145.145,0,0,1,.132.149.141.141,0,0,1-.132.144m-2.322-.213v.134h2.322a.061.061,0,0,0,.058-.065Z",
    transform: "translate(-556.44 12.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7236",
    "data-name": "Caminho 7236",
    d: "M584.993,16.383a.066.066,0,1,1,.132,0v.228h-.132Z",
    transform: "translate(-555.927 11.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7237",
    "data-name": "Caminho 7237",
    d: "M585.456,16.578a.063.063,0,1,1,.125,0v.177h-.125Z",
    transform: "translate(-555.596 11.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7238",
    "data-name": "Caminho 7238",
    d: "M584.527,16.578a.061.061,0,1,1,.122,0v.177h-.122Z",
    transform: "translate(-556.26 11.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7239",
    "data-name": "Caminho 7239",
    d: "M592.605,20.214l.125.132-.093.093.093.087.093-.087.132.132-.086.093.093.1.089-.093.141.134-.216.213a.086.086,0,0,1-.113,0l-.473-.473a.087.087,0,0,1,0-.12l.213-.206Z",
    transform: "translate(-550.659 14.446)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7240",
    "data-name": "Caminho 7240",
    d: "M592.931,21.08l-.086-.034-.492-.494.012-.141.216-.213.185.13-.093.141.093.039.045-.086.18.134-.093.144.1.045.034-.1.192.132Zm-.35-.828-.159.206.509.588.027-.055.213-.209-.139-.077L593,20.8l-.147-.1.093-.144-.132-.087-.045.1-.146-.1.089-.141Z",
    transform: "translate(-550.667 14.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7241",
    "data-name": "Caminho 7241",
    d: "M593.082,20.833l-.65.713-.458-.456.718-.658Z",
    transform: "translate(-550.937 14.602)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7242",
    "data-name": "Caminho 7242",
    d: "M592.443,21.612l-.482-.487.715-.706.442.4Zm.233-1.14-.667.653.427.379.629-.688Z",
    transform: "translate(-550.947 14.592)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7243",
    "data-name": "Caminho 7243",
    d: "M592.732,20.74l.125.129-.086.089.086.093.1-.094.135.129-.1.1.1.093.089-.093.132.132-.209.209a.082.082,0,0,1-.117,0l-.456-.458a.086.086,0,0,1-.009-.113Z",
    transform: "translate(-550.56 14.821)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7244",
    "data-name": "Caminho 7244",
    d: "M593.055,21.6l-.089-.036-.478-.485.021-.141.209-.209.18.127L592.8,21l.093.043.041-.1.188.13-.1.147.1.039.036-.093.189.13Zm-.338-.82-.153.213.49.571.021-.05.219-.211-.132-.077-.036.1-.149-.1.1-.147-.135-.081-.041.1L592.756,21l.093-.146Z",
    transform: "translate(-550.571 14.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7245",
    "data-name": "Caminho 7245",
    d: "M593.092,21.353l-.35.382-.434-.436.377-.36Z",
    transform: "translate(-550.699 14.964)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7246",
    "data-name": "Caminho 7246",
    d: "M592.755,21.8l-.466-.461.382-.413.465.413Zm-.084-.818-.323.357.406.355.323-.355Z",
    transform: "translate(-550.713 14.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7247",
    "data-name": "Caminho 7247",
    d: "M592.072,20.081l.128.125-.089.1.089.093.1-.093.129.125-.093.1.093.093.1-.1.129.139-.213.213a.093.093,0,0,1-.115,0l-.451-.465a.074.074,0,0,1-.007-.11Z",
    transform: "translate(-551.029 14.351)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7248",
    "data-name": "Caminho 7248",
    d: "M592.389,20.939l-.082-.033-.458-.477-.007-.153.213-.211.177.129-.087.149.087.039.041-.094.187.127-.1.149.1.036.038-.093.189.132Zm-.334-.82-.156.216.49.571.027-.048.213-.218-.132-.082-.038.1-.147-.1.092-.149-.132-.072-.041.089-.144-.093.1-.146Z",
    transform: "translate(-551.032 14.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7249",
    "data-name": "Caminho 7249",
    d: "M592.442,20.7l-.353.382-.437-.439.377-.357Z",
    transform: "translate(-551.168 14.497)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7250",
    "data-name": "Caminho 7250",
    d: "M592.1,21.144l-.465-.461.384-.415.458.415Zm-.087-.82-.329.358.417.357.319-.357Z",
    transform: "translate(-551.179 14.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7251",
    "data-name": "Caminho 7251",
    d: "M591.273,21.426a1.027,1.027,0,0,1,1.152-.293,1.04,1.04,0,0,1-.281,1.185Z",
    transform: "translate(-551.439 15.053)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7252",
    "data-name": "Caminho 7252",
    d: "M591.791,20.649l-.748.607.435.437a.845.845,0,0,1,1.084-.216.911.911,0,0,1-.214,1.079l.439.442.6-.76Z",
    transform: "translate(-551.603 14.756)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7253",
    "data-name": "Caminho 7253",
    d: "M592.8,23.064l-.471-.47a.98.98,0,0,0,.213-1.087.813.813,0,0,0-.36-.086.957.957,0,0,0-.667.305l-.489-.432.753-.66,1.643,1.588Zm-.177-1.553a.957.957,0,0,1,.07.285,1.023,1.023,0,0,1-.312.8l.413.362.571-.734Zm-.852-.823-.7.607.442.381a.941.941,0,0,1,1.017-.252Z",
    transform: "translate(-551.614 14.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7254",
    "data-name": "Caminho 7254",
    d: "M591.109,21l1.792,1.8a.11.11,0,0,1-.012.149.116.116,0,0,1-.154.019l-1.8-1.8a.121.121,0,0,1,.171-.165",
    transform: "translate(-551.696 14.986)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7255",
    "data-name": "Caminho 7255",
    d: "M592.81,23.039,592.724,23l-1.8-1.8a.153.153,0,0,1,.014-.2l.115-.053,1.884,1.835a.143.143,0,0,1-.009.2Zm-1.831-1.891L592.81,23l.067-.06-1.785-1.895-.141.135Z",
    transform: "translate(-551.71 14.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7256",
    "data-name": "Caminho 7256",
    d: "M591.406,21.461a.656.656,0,0,1,.694-.206.66.66,0,0,1-.2.7Z",
    transform: "translate(-551.344 15.169)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7257",
    "data-name": "Caminho 7257",
    d: "M591.911,22.027l-.519-.518c.379-.473.724-.273.73-.273a.66.66,0,0,1-.183.763Zm.027-.739a.684.684,0,0,0-.49.221l.458.413a.627.627,0,0,0,.17-.631c-.005.012-.053,0-.137,0",
    transform: "translate(-551.354 15.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7258",
    "data-name": "Caminho 7258",
    d: "M591.675,20.46l1.721,1.721a.1.1,0,0,1,0,.142.115.115,0,0,1-.144.01l-1.72-1.727a.092.092,0,0,1,.005-.135.109.109,0,0,1,.147-.012Z",
    transform: "translate(-551.275 14.605)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7259",
    "data-name": "Caminho 7259",
    d: "M593.329,22.4l-.093-.036-1.72-1.727a.14.14,0,0,1,0-.189l.2-.015,1.725,1.727a.152.152,0,0,1-.007.189Zm-1.667-1.91-.093.1,1.759,1.771.048-.057Z",
    transform: "translate(-551.29 14.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7260",
    "data-name": "Caminho 7260",
    d: "M591.607,20.565l1.65,1.649a.1.1,0,0,1-.012.137.1.1,0,0,1-.135.012l-1.648-1.649a.093.093,0,0,1,.012-.134.1.1,0,0,1,.134-.015",
    transform: "translate(-551.32 14.681)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7261",
    "data-name": "Caminho 7261",
    d: "M593.183,22.424l-.091-.036-1.646-1.643a.139.139,0,0,1,.012-.19l.192-.012,1.646,1.646a.137.137,0,0,1-.007.19ZM591.6,20.6l-.1.089,1.679,1.7.05-.053Z",
    transform: "translate(-551.338 14.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7262",
    "data-name": "Caminho 7262",
    d: "M592.426,20.651c.057-.072.153.019.084.089l-.16.165-.089-.093Z",
    transform: "translate(-550.733 14.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7263",
    "data-name": "Caminho 7263",
    d: "M592.6,21.114a.062.062,0,1,1,.087.087l-.12.129-.093-.091Z",
    transform: "translate(-550.582 15.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7264",
    "data-name": "Caminho 7264",
    d: "M591.936,20.453a.066.066,0,1,1,.093.093l-.125.125-.093-.089Z",
    transform: "translate(-551.054 14.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7265",
    "data-name": "Caminho 7265",
    d: "M592.732,15.939h.18v.135h.13v-.135h.192v.135h.132v-.135h.192v.3a.087.087,0,0,1-.084.081h-.662a.084.084,0,0,1-.081-.082Z",
    transform: "translate(-550.396 11.391)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7266",
    "data-name": "Caminho 7266",
    d: "M593.491,16.369h-.7l-.081-.113v-.3l.219-.039.038.175.094-.039-.039-.1.232-.039.038.175.093-.039-.043-.1.235-.039.036.377Zm-.6-.413-.142.039.031.261.711.082.043-.081v-.3l-.151.036.036.1-.166.033-.039-.168-.153.036.038.1-.17.033Z",
    transform: "translate(-550.412 11.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7267",
    "data-name": "Caminho 7267",
    d: "M593.385,16.182l.041.964-.643,0,.039-.969Z",
    transform: "translate(-550.36 11.558)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7268",
    "data-name": "Caminho 7268",
    d: "M593.465,17.194h-.682v-1l.595-.036Zm-.12-1-.523.027v.933l.568-.033Z",
    transform: "translate(-550.359 11.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7269",
    "data-name": "Caminho 7269",
    d: "M593.2,16.223h.183v.125h.122v-.134h.185v.134h.139v-.134H594v.305a.074.074,0,0,1-.074.074h-.65a.083.083,0,0,1-.084-.074Z",
    transform: "translate(-550.064 11.587)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7270",
    "data-name": "Caminho 7270",
    d: "M593.946,16.647h-.689l-.084-.113v-.3l.223-.041.038.166.084-.038-.033-.1.219-.036.041.17.1-.038-.045-.1.225-.036.038.377Zm-.59-.41-.144.029.033.267.7.074.036-.074v-.305l-.141.036.033.1-.17.039-.036-.173-.151.036.039.1-.161.039Z",
    transform: "translate(-550.081 11.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7271",
    "data-name": "Caminho 7271",
    d: "M593.852,16.435l.019.523h-.621l.015-.523Z",
    transform: "translate(-550.025 11.745)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7272",
    "data-name": "Caminho 7272",
    d: "M593.918,17.009h-.658l-.021-.561.622-.036Zm-.1-.557-.547.039.024.484.542-.036Z",
    transform: "translate(-550.034 11.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7273",
    "data-name": "Caminho 7273",
    d: "M592.27,16.223h.173v.125h.137v-.134h.18v.134h.139v-.134h.182v.305a.076.076,0,0,1-.084.074h-.646a.077.077,0,0,1-.081-.074Z",
    transform: "translate(-550.726 11.587)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7274",
    "data-name": "Caminho 7274",
    d: "M593.013,16.647h-.684l-.082-.113v-.3l.213-.041.039.166.1-.038-.039-.1.218-.036.039.17.1-.038-.039-.1.221-.036.036.377Zm-.583-.41-.144.029.033.267.694.074.048-.074v-.305l-.146.036.038.1-.177.039-.033-.173-.146.036.033.1-.172.039Z",
    transform: "translate(-550.743 11.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7275",
    "data-name": "Caminho 7275",
    d: "M592.922,16.435l.024.523h-.623l.017-.523Z",
    transform: "translate(-550.688 11.745)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7276",
    "data-name": "Caminho 7276",
    d: "M592.3,17.012l.021-.566.617-.033.063.557Zm.6-.562-.545.039.022.448h.583Z",
    transform: "translate(-550.704 11.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7277",
    "data-name": "Caminho 7277",
    d: "M592.61,17.99a1.031,1.031,0,0,1,.607-1.024,1.021,1.021,0,0,1,.634,1.03Z",
    transform: "translate(-550.483 12.124)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7278",
    "data-name": "Caminho 7278",
    d: "M592.355,16.974l-.1.955h.615a.857.857,0,0,1,.61-.916.915.915,0,0,1,.614.916h.622l-.108-.958Z",
    transform: "translate(-550.738 12.128)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7279",
    "data-name": "Caminho 7279",
    d: "M594.762,17.978h-.669a.969.969,0,0,0-.614-.916.834.834,0,0,0-.571.883l-.655.033.06-.989,2.289-.039Zm-1.344-.969-1.063.021-.065.919.579-.043a.819.819,0,0,1,.549-.9m.125,0a.971.971,0,0,1,.59.94l.538-.036-.1-.919Z",
    transform: "translate(-550.738 12.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7280",
    "data-name": "Caminho 7280",
    d: "M592.269,17.531h2.541a.112.112,0,0,1,.1.12.11.11,0,0,1-.1.113h-2.541a.111.111,0,0,1-.1-.113.113.113,0,0,1,.1-.12",
    transform: "translate(-550.798 12.528)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7281",
    "data-name": "Caminho 7281",
    d: "M594.825,17.816h-2.541a.144.144,0,0,1-.134-.149.147.147,0,0,1,.134-.158h2.541a.146.146,0,0,1,.137.158.144.144,0,0,1-.137.149m-2.541-.23v.153h2.541a.071.071,0,0,0,.065-.072Z",
    transform: "translate(-550.812 12.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7282",
    "data-name": "Caminho 7282",
    d: "M592.765,17.8a.649.649,0,0,1,.345-.638.668.668,0,0,1,.355.638Z",
    transform: "translate(-550.372 12.262)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7283",
    "data-name": "Caminho 7283",
    d: "M593.5,17.846h-.739a.447.447,0,1,1,.739-.033Zm-.41-.638a.678.678,0,0,0-.29.605l.615-.039a.6.6,0,0,0-.326-.566",
    transform: "translate(-550.373 12.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7284",
    "data-name": "Caminho 7284",
    d: "M592.3,16.742h2.437a.106.106,0,0,1,0,.209H592.3a.1.1,0,0,1,0-.209",
    transform: "translate(-550.773 11.964)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7285",
    "data-name": "Caminho 7285",
    d: "M594.753,17.006h-2.437a.144.144,0,0,1-.134-.146.136.136,0,0,1,.134-.139h2.437a.132.132,0,0,1,.129.139.139.139,0,0,1-.129.146m-2.437-.209v.129h2.437c.033,0,.053-.027.053-.065Z",
    transform: "translate(-550.788 11.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7286",
    "data-name": "Caminho 7286",
    d: "M592.325,16.865h2.332a.1.1,0,0,1,.089.111.1.1,0,0,1-.089.1h-2.332a.1.1,0,0,1-.088-.1.1.1,0,0,1,.088-.111",
    transform: "translate(-550.749 12.052)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7287",
    "data-name": "Caminho 7287",
    d: "M594.666,17.133h-2.325a.132.132,0,0,1-.125-.141.141.141,0,0,1,.125-.153h2.325a.147.147,0,0,1,.135.153.138.138,0,0,1-.135.141m-2.325-.213v.141h2.325a.065.065,0,0,0,.057-.069Z",
    transform: "translate(-550.765 12.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7288",
    "data-name": "Caminho 7288",
    d: "M592.933,16.382a.066.066,0,1,1,.132,0v.237h-.132Z",
    transform: "translate(-550.252 11.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7289",
    "data-name": "Caminho 7289",
    d: "M593.4,16.578a.063.063,0,1,1,.125,0v.177H593.4Z",
    transform: "translate(-549.921 11.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7290",
    "data-name": "Caminho 7290",
    d: "M592.469,16.577a.059.059,0,1,1,.117,0v.183h-.117Z",
    transform: "translate(-550.584 11.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7291",
    "data-name": "Caminho 7291",
    d: "M585.182,20.795l.132-.129.089.093.1-.1-.1-.093.136-.137.1.1.093-.1-.093-.1.129-.132.213.213a.076.076,0,0,1,0,.113l-.466.468a.086.086,0,0,1-.12.005Z",
    transform: "translate(-555.791 14.439)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7292",
    "data-name": "Caminho 7292",
    d: "M585.452,21.078l-.081-.038-.206-.207.129-.182.144.089.045-.093-.093-.043.137-.185.147.091.038-.093-.1-.043.132-.185.3.238-.033.144Zm-.158-.374-.072.129.23.2.04-.057.47-.468-.213-.269-.074.132.089.043-.089.153-.147-.1-.089.134.1.043-.1.146Z",
    transform: "translate(-555.803 14.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7293",
    "data-name": "Caminho 7293",
    d: "M585.8,20.429l.712.658-.454.453-.655-.713Z",
    transform: "translate(-555.635 14.599)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7294",
    "data-name": "Caminho 7294",
    d: "M586.068,21.606l-.682-.748.4-.446.766.655Zm-.285-1.14-.345.4.629.633.425-.425Z",
    transform: "translate(-555.646 14.588)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7295",
    "data-name": "Caminho 7295",
    d: "M585.707,20.651l.129-.129.089.1.1-.1-.1-.093.137-.125.093.089.093-.089-.093-.1.132-.125.213.213a.067.067,0,0,1,0,.106l-.463.461a.081.081,0,0,1-.115,0Z",
    transform: "translate(-555.416 14.35)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7296",
    "data-name": "Caminho 7296",
    d: "M585.981,20.937,585.9,20.9l-.213-.209.125-.18.149.091.036-.091-.093-.038.129-.187.153.094.036-.094-.1-.041.137-.185.269.233-.005.147Zm-.165-.374-.072.129.237.207.039-.055.451-.454-.206-.269-.081.125.1.041-.091.147-.153-.1-.077.135.1.038-.091.144Z",
    transform: "translate(-555.428 14.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7297",
    "data-name": "Caminho 7297",
    d: "M586.324,20.282l.377.357-.43.439-.364-.379Z",
    transform: "translate(-555.273 14.494)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7298",
    "data-name": "Caminho 7298",
    d: "M586.275,21.14l-.381-.413.413-.46.434.355Zm.033-.82-.362.406.329.305.41-.41Z",
    transform: "translate(-555.283 14.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7299",
    "data-name": "Caminho 7299",
    d: "M585.05,21.308l.125-.122.1.093.093-.093-.1-.1.132-.129.092.093.1-.093-.1-.089.127-.135.218.213a.076.076,0,0,1,0,.108l-.461.463a.082.082,0,0,1-.113,0Z",
    transform: "translate(-555.886 14.817)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7300",
    "data-name": "Caminho 7300",
    d: "M585.332,21.586l-.084-.029-.213-.209.125-.183.156.093.036-.093-.1-.038.135-.185.142.1.046-.1-.1-.041.132-.18.266.221-.005.147Zm-.172-.37-.077.132.249.2.029-.051.461-.458-.213-.273-.079.132.094.041-.094.144-.142-.093-.079.132.091.038-.084.144Z",
    transform: "translate(-555.897 14.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7301",
    "data-name": "Caminho 7301",
    d: "M585.665,20.937l.381.357-.434.442-.357-.382Z",
    transform: "translate(-555.739 14.962)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7302",
    "data-name": "Caminho 7302",
    d: "M585.625,21.8l-.389-.41.417-.466.435.355Zm.032-.82-.369.41.336.305.406-.41Z",
    transform: "translate(-555.753 14.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7303",
    "data-name": "Caminho 7303",
    d: "M586.393,22.3a1.048,1.048,0,0,1-.293-1.159,1.033,1.033,0,0,1,1.18.281Z",
    transform: "translate(-555.183 15.05)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7304",
    "data-name": "Caminho 7304",
    d: "M585.618,22.24l.6.748.437-.442a.835.835,0,0,1-.213-1.08.912.912,0,0,1,1.077.218l.441-.446-.758-.595Z",
    transform: "translate(-555.48 14.751)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7305",
    "data-name": "Caminho 7305",
    d: "M586.225,23.049l-.624-.775,1.591-1.648.8.595-.434.5a1.187,1.187,0,0,0-.718-.291.844.844,0,0,0-.37.084.832.832,0,0,0,.225,1.018Zm.159-1.531-.734.76.581.665.41-.413a.856.856,0,0,1-.329-.773.991.991,0,0,1,.072-.238m.458-.168a1.038,1.038,0,0,1,.718.312l.389-.432-.758-.55-.708.746a.876.876,0,0,1,.358-.075",
    transform: "translate(-555.492 14.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7306",
    "data-name": "Caminho 7306",
    d: "M585.964,22.784l1.79-1.794a.117.117,0,0,1,.156.01.123.123,0,0,1,.014.154l-1.8,1.8a.12.12,0,0,1-.165-.168",
    transform: "translate(-555.251 14.982)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7307",
    "data-name": "Caminho 7307",
    d: "M586.08,23.026l-.115-.051a.164.164,0,0,1-.015-.206l1.79-1.8c.135-.038.177-.017.211.019a.163.163,0,0,1,.01.206Zm1.756-2.015L586,22.825l-.015.122.091.036.033-.048,1.8-1.8.012-.129Z",
    transform: "translate(-555.264 14.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7308",
    "data-name": "Caminho 7308",
    d: "M586.432,21.941a.657.657,0,0,1-.213-.688.661.661,0,0,1,.7.2Z",
    transform: "translate(-555.069 15.167)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7309",
    "data-name": "Caminho 7309",
    d: "M586.447,22.019l-.027-.027a.677.677,0,0,1-.214-.734c.045-.045.374-.189.756.189Zm-.2-.71a.68.68,0,0,0,.2.605l.465-.468a.788.788,0,0,0-.662-.137",
    transform: "translate(-555.085 15.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7310",
    "data-name": "Caminho 7310",
    d: "M585.427,22.177l1.721-1.721a.1.1,0,0,1,.142.007.106.106,0,0,1,0,.144l-1.72,1.718a.093.093,0,0,1-.139-.007.1.1,0,0,1-.009-.141",
    transform: "translate(-555.634 14.598)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7311",
    "data-name": "Caminho 7311",
    d: "M585.515,22.385l-.108-.062-.005-.173,1.72-1.721.2.005a.154.154,0,0,1,.005.2Zm0-.077v.039l.036-.051,1.718-1.718.024-.117-.079,0L585.455,22.2l-.017.113Z",
    transform: "translate(-555.634 14.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7312",
    "data-name": "Caminho 7312",
    d: "M585.535,22.212l1.642-1.649a.1.1,0,0,1,.141.009.1.1,0,0,1,.01.141l-1.646,1.649a.1.1,0,0,1-.136-.012c-.039-.041-.051-.108-.012-.137",
    transform: "translate(-555.556 14.678)",
    fill: "#fcff2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7313",
    "data-name": "Caminho 7313",
    d: "M585.643,22.425l-.111-.048a.14.14,0,0,1-.009-.189l1.653-1.653.185.012a.14.14,0,0,1,.017.192Zm0-.075v.036l.031-.045,1.648-1.653.012-.113-.077,0-1.679,1.663-.016.111Z",
    transform: "translate(-555.571 14.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7314",
    "data-name": "Caminho 7314",
    d: "M585.628,20.732a.065.065,0,1,1,.093-.089l.16.166-.088.087Z",
    transform: "translate(-555.49 14.735)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7315",
    "data-name": "Caminho 7315",
    d: "M586.093,20.54a.062.062,0,1,1,.088-.087l.125.127-.088.086Z",
    transform: "translate(-555.156 14.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7316",
    "data-name": "Caminho 7316",
    d: "M585.435,21.2a.063.063,0,1,1,.089-.087l.127.127-.087.086Z",
    transform: "translate(-555.626 15.071)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPor);
export default __webpack_public_path__ + "static/media/flag_POR.b3764f783d009659228fd29dc96ec60f.svg";
export { ForwardRef as ReactComponent };